<!-- eslint-disable max-len -->
<template>
  <f7-page class="div-frmPaletizadoInicio">
    <div class="menu">
      <PCSideNavbar
        show-more-button
        @item-clicked="OpcionSideNavbarSeleccionada"
      />
    </div>
    <div class="div-contenido">
      <f7-row class="no-padding">
        <f7-col
          width="100"
          class="no-padding"
        >
          <f7-row style="height: 15vh;">
            <f7-col
              width="25"
              style="max-width: 250px; margin-top: 18px; border-right: 1px solid rgb(151 151 151 / 30%);"
            >
              <span v-if="logoApp">
                <img
                  id="logo"
                  alt="logoEmpresa"
                  class="logo-empresa-frmTablet"
                  :src="logoApp"
                >
              </span>
              <span v-else>
                <img
                  id="logo"
                  alt="logoEmpresa"
                  class="logo-empresa-frmTablet"
                  :src="LOGO_HISPATEC"
                >
              </span>
            </f7-col>
            <f7-col
              width="40"
              class="temp-padding-top"
            >
              <UCSearchEntityERP
                :placeholder="$t('common.productionLine')"
                :search-text="$t('searchEntity.line.searchText')"
                :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
                :default-value="lineaSeleccionadaAlIniciarFormulario"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :next-and-previous-buttons-shown="true"
                :autofocus-on-deselection="true"
                :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true"
                :auto-focus-on-empty-search-result="true"
                :emit-evet-change-default-value="true"
                :default-etities-list="lineasProduccion"
                @selection="LineaProduccionSeleccionada"
              />
            </f7-col>
            <f7-col
              width="25"
              class="div-logoHispatecDerecha"
            >
              <img
                id="logo"
                alt="logoHispatec"
                class="img-logoHispatec"
                :src="LOGO_HISPATEC"
              >
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="20">
          <div class="div-cabecera-puntos">
            <span class="span-tituloColumnas no-seleccionable">
              {{ $t('production.palletizing.labels.palletizingPoints') }}
            </span>
            <div class="seleccionable btn-opciones-puntos">
              <span
                v-if="puntoDePaletizadoSeleccionado != null ? true : false"
                @click="AbrirOpcionesPuntoPaletizadoSeleccionado"
              > <img
                src="@/static/icons/ic_edit_gray.svg"
                alt="iconEdit"
                width="15px"
              > </span>
            </div>
          </div>
          <div class="div-puntosPaletizadoDisponibles">
            <div
              v-for="punto in puntosDePaletizado"
              :key="punto.Id"
              class="div-elementoTarjetaLinea seleccionable"
              :class="{
                'div-elementoTarjetaLineaSeleccionada': punto === puntoDePaletizadoSeleccionado ? true : false,
                'div-elementoTarjetaLineaDeshabilitada': (contadorDeLlamadasPendientesDeRespuestaEnFrm !== 0 && punto !== puntoDePaletizadoSeleccionado) ? true : false,
              }"
              @click="PuntoDePaletizadoSeleccionado(punto)"
            >
              <div
                v-if="activePalletSettings.view && punto.PaleActivo"
                :class="{ 'div-puntosPaletizadoDisponibles__orange-icon': !!punto.PaleActivo }"
              />

              <span>{{ punto.Nombre }}</span>

              <span
                v-if="punto.UbicacionDefectoPalesProducidos != null
                  && punto.UbicacionPalesProducidos != null
                  && punto.UbicacionPalesProducidos.Id !== punto.UbicacionDefectoPalesProducidos.Id"
                class="span-ubic-salida-mod"
              >
                {{
                  $t('production.palletizing.activePallet.location', {
                    name: punto.UbicacionPalesProducidos.Nombre,
                  })
                }}
              </span>

              <PCOperacionesPersonalizadas
                v-if="personalizacionPuntoPalrtizadoActiva
                  && puntoDePaletizadoSeleccionado != null
                  && punto.Id === puntoDePaletizadoSeleccionado.Id"
                :app-theme="appTheme"
                :tipo-entidad="0"
                :entidad="puntoDePaletizadoSeleccionado"
                :parametros="[puntoDePaletizadoSeleccionado.Id]"
                formulario-padre="frmPaletizado"
                componente-aplicacion="PCSelectorPuntoPaletizado"
                :mostrar-precarga="false"
              />

              <div
                v-if="activePalletSettings.view
                  && punto.PaleActivo
                  && punto.PaleActivo.TipoEnvasadoElementoProduccion
                  && punto.PaleActivo.PuntoPaletizadoRegistro"
                class="div-puntosPaletizadoDisponibles__pale-activo-info"
              >
                <div v-if="activePalletSettings.showSalesOrder && GetSalesOrderTextForActivePallet(punto.PaleActivo)">
                  {{ GetSalesOrderTextForActivePallet(punto.PaleActivo) }}
                </div>

                <div v-if="activePalletSettings.showCustomerName && GetCustomerNameTextForActivePallet(punto.PaleActivo)">
                  {{ GetCustomerNameTextForActivePallet(punto.PaleActivo) }}
                </div>

                <div v-if="activePalletSettings.showSerialNumber && punto.PaleActivo.PuntoPaletizadoRegistro.ArticuloNumeroSerie?.NumeroSerie">
                  {{ punto.PaleActivo.PuntoPaletizadoRegistro.ArticuloNumeroSerie.NumeroSerie }}
                </div>

                <div
                  v-if="(activePalletSettings.showProduct && punto.PaleActivo.TipoEnvasadoElementoProduccion.Articulo)
                    || (activePalletSettings.showPackage && punto.PaleActivo.TipoEnvasadoElementoProduccion.Envase)
                    || (activePalletSettings.showPallet && punto.PaleActivo.TipoEnvasadoElementoProduccion.Pale)"
                >
                  <div v-if="activePalletSettings.showProduct && punto.PaleActivo.TipoEnvasadoElementoProduccion.Articulo">
                    {{ `* ${punto.PaleActivo.TipoEnvasadoElementoProduccion.Articulo.Nombre}` }}
                  </div>

                  <div v-if="activePalletSettings.showPackage && punto.PaleActivo.TipoEnvasadoElementoProduccion.Envase">
                    {{ `* ${punto.PaleActivo.TipoEnvasadoElementoProduccion.Envase.Nombre}` }}
                  </div>

                  <div v-if="activePalletSettings.showPallet && punto.PaleActivo.TipoEnvasadoElementoProduccion.Pale">
                    {{ `* ${punto.PaleActivo.TipoEnvasadoElementoProduccion.Pale.Nombre}` }}
                  </div>
                </div>

                <div v-if="activePalletSettings.showPackagesPerPallet && punto.PaleActivo.TipoEnvasadoElementoProduccion.EnvasesPorPale">
                  {{ `${$t('common.packagesPerPallet')}: ${punto.PaleActivo.TipoEnvasadoElementoProduccion.EnvasesPorPale}` }}
                </div>
              </div>
            </div>
          </div>
        </f7-col>
        <f7-col width="45">
          <span class="span-tituloColumnas no-seleccionable">
            {{ $t('common.now') }}
          </span>
          <div class="div-contenedorCentralPedidos ">
            <f7-row>
              <f7-col width="100">
                <!-- Barra de Opciones -->
                <div
                  class="div-barraDeOpcionesPlanificacion"
                  :class="{ 'disabled-component': puntoDePaletizadoSeleccionado != null && puntoDePaletizadoSeleccionado.UsoEnIntegracion }"
                >
                  <div class="div-btnIzquierda">
                    <span
                      class="btn-cuadrado-grisClaro-40 seleccionable"
                      @click="NuevoPaleSinPedidoPlanificado()"
                    > <img
                      alt="iconAdd"
                      src="@/static/icons/ic_new_white.svg"
                    > </span>
                    <span
                      class="seleccionable"
                      :class="{
                        'btn-cuadrado-grisClaro-40': habilitarEdicion,
                        'btn-cuadrado-grisOscuro-40': !habilitarEdicion,
                      }"
                      @click="MostrarEdicionDePaleEnCurso()"
                    > <img
                      src="@/static/icons/ic_edit_gray.svg"
                      alt="iconEdit"
                      width="15px"
                    > </span>
                    <span
                      class="seleccionable"
                      :class="{
                        'btn-cuadrado-grisClaro-40': habilitarEdicion,
                        'btn-cuadrado-grisOscuro-40': !habilitarEdicion,
                      }"
                      @click="SolicitudEliminarPaleEnCursoEnPuntoPaletizado(false)"
                    > <img
                      alt="iconTrassh"
                      src="@/static/icons/ic_trash_gray.svg"
                      width="15px"
                    > </span>
                    <span
                      class="seleccionable"
                      :class="{
                        'btn-cuadrado-grisClaro-40': puntoDePaletizadoSeleccionado === null ? false : true,
                        'btn-cuadrado-grisOscuro-40': puntoDePaletizadoSeleccionado != null ? false : true,
                      }"
                      @click="AbrirPopupParaBusquedaDePales()"
                    > <img
                      class="img-btnModoInput"
                      alt="iconBarCode"
                      src="@/static/icons/ic_code.svg"
                      width="32"
                      height="32"
                    > </span>
                    <span
                      class="seleccionable"
                      :class="{
                        'btn-cuadrado-grisClaro-40': habilitarRegistroProductividadTrabajadores,
                        'btn-cuadrado-grisOscuro-40': !habilitarRegistroProductividadTrabajadores,
                      }"
                      @click="habilitarRegistroProductividadTrabajadores ? AbrirPopupParaRegistrarCajasPale() : null"
                    > <img
                      class="img-btnModoInput"
                      alt="iconPaletizado"
                      src="@/static/icons/ic_batch_2.svg"
                      width="32"
                      height="32"
                    > </span>
                    <span
                      class="seleccionable"
                      :class="{
                        'btn-cuadrado-grisClaro-40': !habilitarEdicion && pedidoSeleccionado,
                        'btn-cuadrado-grisOscuro-40': habilitarEdicion || !pedidoSeleccionado,
                      }"
                      @click="!habilitarEdicion && pedidoSeleccionado ? EliminadoPedidoPlanificadoEnPuntoPaletizado(pedidoSeleccionado) : null"
                    > <img
                      class="img-btnModoInput"
                      alt="iconPaletizado"
                      src="@/static/icons/close_icon.svg"
                      width="32"
                      height="32"
                    > </span>
                  </div>
                  <div class="div-btnDerecha">
                    <span
                      class="seleccionable"
                      :class="{
                        'btn-cuadrado-grisClaro-40': pedidoSeleccionado != null ? true : false,
                        'btn-cuadrado-grisOscuro-40': pedidoSeleccionado == null ? true : false,
                      }"
                      @click="SubirPrioridadDePedidosSeleccionados()"
                    > <img
                      src="@/static/icons/ic_up_2.svg"
                      alt="iconUp"
                      width="17px"
                    > </span>
                    <span
                      class="seleccionable"
                      :class="{
                        'btn-cuadrado-grisClaro-40': pedidoSeleccionado != null ? true : false,
                        'btn-cuadrado-grisOscuro-40': pedidoSeleccionado == null ? true : false,
                      }"
                      @click="BajarPrioridadDePedidosSeleccionados()"
                    > <img
                      src="@/static/icons/ic_arrow_down_1.svg"
                      alt="iconDown"
                      width="17px"
                    > </span>
                  </div>
                </div>
              </f7-col>
            </f7-row>
            <!-- Palé en Curso No planificado desde Pedido Venta -->
            <div
              v-if="paleEnCursoSinPlanificar != null && pedidoEnCurso == null"
              class="div-paleEnCursoNoPlanificado no-padding"
            >
              <div
                class="div-elementoTarjeta div-tarjetaPaleSinPedido"
                :class="{ 'div-elementoTarjetaSeleccionado': paleEnCursoSinPlanificarSeleccionado != null ? true : false }"
                @click="SeleccionarPaleEnCursoNoPlanificado()"
              >
                <f7-row
                  :class="{
                    'row-cabeceraTarjetaSeleccionada': paleEnCursoSinPlanificarSeleccionado != null ? true : false,
                    'row-cabeceraTarjeta': paleEnCursoSinPlanificarSeleccionado == null ? true : false,
                  }"
                >
                  <f7-col
                    width="60"
                    style="margin-left: 10px;"
                  >
                    <span class="span-texto-azulOscuro-18-500 span-textoCabeceraTarjetaPedido">
                      {{ $t('common.pallet') }}
                    </span>
                  </f7-col>
                  <f7-col
                    width="40"
                    class="div-cabeceraTarjetaDerecha"
                  >
                    <div
                      v-if="paleReabiertoEnPuntoDePaletizado != null"
                      class="div-rectanguloReabierto"
                    >
                      <span>{{ $t('production.palletizing.labels.reopened').toUpperCase() }}</span>
                    </div>
                    <div class="div-rectanguloEnCurso">
                      <span>{{ $t('common.inProcessWay').toUpperCase() }}</span>
                    </div>
                  </f7-col>
                </f7-row>
                <f7-row class="row-pedido">
                  <f7-col
                    width="15"
                    style="display: flex;"
                  >
                    <span
                      class="btn-oval-amarillo-46 seleccionable"
                      :class="{ 'disabled-component': puntoDePaletizadoSeleccionado != null && puntoDePaletizadoSeleccionado.UsoEnIntegracion }"
                      @click="FinalizarPaleEnCursoNoPlanificado(paleReabiertoEnPuntoDePaletizado == null, true)"
                    ><img
                      src="@/static/icons/ic_check_off.svg"
                      alt="iconTickOff"
                      width="23px"
                    ></span>
                  </f7-col>
                  <f7-col width="85">
                    <f7-row class="row-producto no-padding">
                      <f7-col width="100" />
                      <span class="span-texto-azulOscuro-16-500">
                        {{ paleEnCursoSinPlanificar.Articulo.Nombre }}
                      </span>
                    </f7-row>

                    <f7-row class="row-envase no-padding">
                      <f7-col width="100" />
                      <span class="span-texto-gris-14-500">
                        {{ paleEnCursoSinPlanificar.Envase.Nombre }}
                      </span>
                    </f7-row>

                    <f7-row class="row-paleYCamara no-padding">
                      <f7-col width="100" />
                      <div class="footer">
                        <span class="span-texto-azulOscuro-14-500">
                          {{ paleEnCursoSinPlanificar.Pale.Nombre }}
                        </span>
                        <div
                          v-if="puntoDePaletizadoSeleccionado.UtilizarUIC && puntoDePaletizadoSeleccionado.TipoFinPalet === 0"
                          class="footer-quantity"
                        >
                          {{ `${articuloAsignados} ${$t('common.of')} ${totalEnvases === 0 ? articuloAsignados : totalEnvases}` }}
                        </div>
                      </div>
                    </f7-row>
                  </f7-col>
                </f7-row>
              </div>
            </div>

            <!-- Pedidos Planificados del Punto de Paletizado -->
            <div
              class="div-pedidosPlanificados"
              :class="{
                'div-pedidosPlanificadosContenedorGrande': paleEnCursoSinPlanificar == null ? true : false,
                'div-pedidosPlanificadosContenedorPequeno': paleEnCursoSinPlanificar != null ? true : false,
              }"
              aria-dropeffect="none"
            >
              <UCPreload :show="mostrarPrecarga" />
              <VueDraggableNext
                v-model="listadoPedidosPlanificados"
                group="pedidosPendientes"
                :move="SolicitudCambioDeOrden"
                :options="dragOptions"
                handle=".handle"
                @start="drag = true"
                @end="CambioDeOrdenFinalizado()"
              >
                <transition-group
                  type="transition"
                  :name="!drag ? 'flip-list' : null"
                >
                  <div
                    v-for="pedido in listadoPedidosPlanificados"
                    :key="`${pedido.IdPedidoVenta}-${pedido.IdLineaPedidoVenta}`"
                    class="div-elementoTarjeta"
                    :class="{
                      'div-elementoTarjetaSeleccionado': pedido === pedidoSeleccionado ? true : false,
                      'no-movible': puntoDePaletizadoSeleccionado != null
                        && puntoDePaletizadoSeleccionado.UsoEnIntegracion,
                      'movible': puntoDePaletizadoSeleccionado != null && !puntoDePaletizadoSeleccionado.UsoEnIntegracion,
                    }"
                    style="background: res;"
                    @click="SeleccionarPedido(pedido)"
                  >
                    <f7-row
                      :class="{
                        'row-cabeceraTarjetaSeleccionada': pedido === pedidoSeleccionado ? true : false,
                        'row-cabeceraTarjeta': pedido !== pedidoSeleccionado ? true : false,
                      }"
                    >
                      <f7-col
                        width="5"
                        style="margin-left: 10px;"
                      >
                        <img
                          src="@/static/icons/ic_move.svg"
                          alt="iconMove"
                          class="handle"
                        >
                      </f7-col>
                      <f7-col
                        width="55"
                        style="margin-left: 10px;"
                      >
                        <img
                          v-if="pedido.MensajesInformacion != null && pedido.MensajesInformacion.length > 0"
                          alt="iconWrning"
                          src="@/static/icons/ic_warning.svg"
                        >
                        <span class="span-texto-azulOscuro-18-500 span-textoCabeceraTarjetaPedido">
                          {{ `${pedido.Pedido}-${pedido.Orden} ${pedido.NombreCliente || pedido.AliasCliente}` }}
                        </span>
                      </f7-col>
                      <f7-col
                        width="40"
                        class="div-cabeceraTarjetaDerecha"
                      >
                        <div
                          v-if="pedido === pedidoEnCurso && ComprobarSiElTipoEnvasadoDelPedidoEsIgualAlTipoEnvasadoDelPaleEnCurso(pedido)"
                          class="div-rectanguloModificado"
                        >
                          <span>{{ $t('production.palletizing.labels.modified') }}</span>
                        </div>
                        <div
                          v-if="pedido === pedidoEnCurso && pedido.PaleReabierto"
                          class="div-rectanguloReabierto"
                        >
                          <span>{{ $t('production.palletizing.labels.reopened').toUpperCase() }}</span>
                        </div>
                        <div
                          v-if="pedido === pedidoEnCurso"
                          class="div-rectanguloEnCurso"
                        >
                          <span>{{ $t('common.inProcessWay').toUpperCase() }}</span>
                        </div>
                        <span class="btn-oval-azulOscuro-26">{{ pedido.CantidadPalet }}</span>
                      </f7-col>
                    </f7-row>
                    <f7-row class="row-pedido">
                      <f7-col
                        width="15"
                        style="display: flex;"
                      >
                        <!-- Iniciar Pedido -->
                        <span
                          v-if="pedido !== pedidoEnCurso && pedido.TipoEstado !== 1"
                          class="btn-oval-azulOscuro-46 seleccionable"
                          :class="{ 'disabled-component': puntoDePaletizadoSeleccionado != null && puntoDePaletizadoSeleccionado.UsoEnIntegracion }"
                          @click="IniciarPedido(pedido, true, true)"
                        >
                          <img
                            src="@/static/icons/ic_play.svg"
                            alt="iconPlay"
                            width="16px"
                          >
                        </span>
                        <span
                          v-if="pedido === pedidoEnCurso && pedido.TipoEstado === 1"
                          class="btn-oval-amarillo-46 seleccionable"
                          :class="{ 'disabled-component': (puntoDePaletizadoSeleccionado != null && puntoDePaletizadoSeleccionado.UsoEnIntegracion) }"
                          @click="actualizarConfeccionPrevistaFamiliaGenericaPedido
                            ? FinalizarPalePlanificadoConCambioVariedad(pedido)
                            : FinalizarPalePlanificado(pedido, !pedido.PaleReabierto, true)"
                        ><img
                          src="@/static/icons/ic_check_off.svg"
                          alt="iconTickOff"
                          width="23px"
                        ></span>
                      </f7-col>
                      <f7-col width="65">
                        <f7-row class="row-producto no-padding">
                          <f7-col width="100">
                            <span class="span-texto-azulOscuro-16-500">
                              {{ pedido.Producto.Nombre }}
                            </span>
                          </f7-col>
                        </f7-row>

                        <f7-row class="row-envase no-padding">
                          <f7-col width="100" />
                          <span class="span-texto-gris-14-400">
                            {{ pedido.Envase.Nombre }}
                          </span>
                        </f7-row>

                        <f7-row class="row-paleYCamara no-padding">
                          <f7-col width="100" />

                          <div>
                            <span class="span-texto-azulOscuro-14-500">
                              {{ `${pedido.Pale.Codigo}-${pedido.Pale.Nombre} → ${pedido.Marca.Nombre}` }}

                              <span
                                v-if=" pedido.ReferenciaPedidoVenta"
                                class="span-texto-azulOscuro-14-500"
                              >
                                {{ `→ ${$t('common.referenceShort')}: ${pedido.ReferenciaPedidoVenta}` }}
                              </span>
                              <span v-if="pedido.Lote?.Codigo">
                                {{ `→ ${pedido.Lote.Codigo}` }}
                              </span>
                              <span v-if="pedido.Confeccion?.Codigo">
                                {{ `→ ${$t('common.assembly')}: ${pedido.Confeccion.Codigo}` }}
                              </span>

                            </span> <span v-if="pedido.AliasCliente">
                              {{ `${$t('common.alias')}: ${pedido.AliasCliente}` }}
                            </span>
                            <div class="margin-bottom">
                              <span
                                v-if="puntoDePaletizadoSeleccionado?.UtilizarUIC && !noMostrarEnvasesConfeccionadosUIC"
                                class="span-texto-azulOscuro-14-500"
                              >
                                {{
                                  `${$t('production.palletizing.indicators.assembledPackages')}: ${pedido.EnvasesConfeccionados}
                                  ${$t('common.of')} ${pedido.CantidadPalesTotalesDeLaLineaPedido * pedido.CantidadEnvasesPorPalet}`
                                }}
                              </span>
                            </div>
                          </div>

                          <PCOperacionesPersonalizadas
                            v-if="personalizacionPCTarjetaPlanificacionActiva"
                            :entidad="{ Id: pedido.IdLineaPedidoVenta }"
                            :tipo-entidad="0"
                            formulario-padre="frmPaletizado"
                            componente-aplicacion="PCTarjetaPlanificacion"
                            :mostrar-precarga="true"
                            :modo-consulta-agrupada="true"
                            :datos="datosLineasPedidoParaPersonalizaciones"
                          />
                        </f7-row>
                      </f7-col>
                      <f7-col width="20">
                        <div class="img-details">
                          <img
                            src="@/static/icons/ic_options_dark.svg"
                            alt="iconSetting"
                            class="seleccionable"
                            @click="MostrarDetalleLineaPedidoPlanificado(pedido)"
                          >
                        </div>
                        <div class="footer-planificado">
                          <div
                            v-if="pedido === pedidoEnCurso && puntoDePaletizadoSeleccionado.UtilizarUIC && puntoDePaletizadoSeleccionado.TipoFinPalet === 0"
                            class="footer-quantity"
                          >
                            {{ `${articuloAsignados} ${$t('common.of')} ${totalEnvases === 0 ? articuloAsignados : totalEnvases}` }}
                          </div>
                        </div>
                      </f7-col>
                    </f7-row>
                    <!-- Indicadores del pedido -->
                    <f7-row class="row-indicadoresPedido ">
                      <f7-col
                        width="20"
                        class="col-rectanguloIndicadorDePedido"
                      >
                        <span class="span-valorInidicadorDePedido">
                          {{ Math.round((pedido.CantidadEnvasesPorPalet)) }}
                        </span>
                        <span class="span-texto-gris-12-400">
                          {{ $t('production.palletizing.indicators.packagesPallet') }}
                        </span>
                      </f7-col>
                      <f7-col
                        width="20"
                        class="col-rectanguloIndicadorDePedido"
                      >
                        <span class="span-valorInidicadorDePedido">
                          {{ (pedido.UnidadesPorEnvase) }}
                        </span>
                        <span class="span-texto-gris-12-400">
                          {{ $t('production.palletizing.indicators.unitsPackage') }}
                        </span>
                      </f7-col>
                      <f7-col
                        width="20"
                        class="col-rectanguloIndicadorDePedido"
                      >
                        <span class="span-valorInidicadorDePedido">
                          {{ Math.round(pedido.CantidadEnvasesPorPalet * pedido.CantidadPalet) }}
                        </span>

                        <span class="span-texto-gris-12-400">
                          {{ $t('production.palletizing.indicators.totalPackages') }}
                        </span>
                      </f7-col>
                      <f7-col
                        width="20"
                        class="col-rectanguloIndicadorDePedido"
                      >
                        <span class="span-valorInidicadorDePedido">
                          {{ FormatearXDecimales((pedido.PesoBruto / pedido.CantidadPalesTotalesDeLaLineaPedido * pedido.CantidadPalet), 2) }}
                        </span>
                        <span class="span-texto-gris-12-400">
                          {{ $t('common.grossWeightShort') }}
                        </span>
                      </f7-col>
                      <f7-col
                        width="20"
                        class="col-rectanguloIndicadorDePedido"
                      >
                        <span class="span-valorInidicadorDePedido">

                          {{ FormatearXDecimales((pedido.PesoNeto / pedido.CantidadPalesTotalesDeLaLineaPedido * pedido.CantidadPalet), 2) }}
                        </span>
                        <span class="span-texto-gris-12-400">
                          {{ $t('common.netWeightShort') }}
                        </span>
                      </f7-col>
                    </f7-row>
                  </div>
                </transition-group>
              </VueDraggableNext>
            </div>
          </div>
        </f7-col>
        <f7-col width="35">
          <span
            v-if="lineaSeleccionada == null"
            class="span-tituloColumnas"
          >
            {{ $t('common.summary') }}
          </span>
          <span
            v-if="lineaSeleccionada != null"
            class="span-tituloColumnas"
          >
            {{ $t('production.palletizing.labels.lineSummary') }}
          </span>

          <span
            v-if="lineaSeleccionada != null"
            data-v-48a14169=""
            class="btn-oval-azulOscuro-26 btn-actualizarPartidasYPalesGenerados seleccionable"
            @click="ActualizarPlanificadoYPartidasYPalesGenerados()"
          >
            {{ $t('production.palletizing.labels.btnRefreshText') }}
          </span>

          <span
            v-if="lineaSeleccionada != null"
            data-v-48a14169=""
            class="btn-oval-azulOscuro-26 btn-resetearVolcadosActivos seleccionable"
            @click="ResetearVolcadosActivos()"
          >
            {{ $t('production.palletizing.labels.btnResetText') }}
          </span>

          <div class="div-contenedorPartidasLinea">
            <div class="cabecera">
              <span class="span-texto-azulOscuro-14-500">
                {{ $t('common.batches').toUpperCase() }}
              </span>
            </div>
            <div class="div-contenidoComponentePCPartidasActivasYRecintesLinea">
              <PCPartidasActivasYRecientesLinea
                v-if="lineaSeleccionada != null"
                ref="componentePCPartidasActivasYRecientesLinea"
                :intervalo-actualizacion-automatica="60"
                :punto-paletizado-seleccionado="puntoDePaletizadoSeleccionado"
                :trabajar-con-asignacion-de-partidas-por-pedido="lineaSeleccionada != null ? lineaSeleccionada.AsignarDatosOrigenPorPedido : false"
                :linea-produccion-seleccionada="lineaSeleccionada === null ? lineasDeProduccionDelUsuarioDefinidaEnERP : lineaSeleccionada"
                @partidas-activas="EventPartidasActivas"
                @inicio-carga-datos="contadorDeLlamadasPendientesDeRespuestaEnFrm++"
                @fin-carga-datos="contadorDeLlamadasPendientesDeRespuestaEnFrm--"
              />
            </div>
            <!-- Ver Mas -->
            <div
              v-if="lineaSeleccionada != null"
              class="div-verMas seleccionable"
            >
              <span
                class="span-verMas display-flex justify-content-center"
                @click="$refs.componentePCPartidasActivasYRecientesLinea.VerMasPartidasDeLaColaDeVolcado()"
              >
                {{ $t('common.seeMore').toUpperCase() }}
              </span>
            </div>
          </div>
          <div class="div-contenedorUltimosPalesGenerados">
            <div class="cabecera">
              <span class="span-texto-azulOscuro-14-400">
                {{ $t('production.palletizing.labels.lastPallets').toUpperCase() }}
              </span>
            </div>
            <div class="div-contenidoComponentePCUltimosPalesGenerados">
              <PCUltimosPalesGenerados
                ref="componentePCUltimosPalesGenerados"
                :mostrar-titulo="false"
                :nombre-popup-frm="nombreFrmPCUltimosPalesGenerados"
                :mostrar-buscador="true"
                :mostrar-btn-retrabajar-pale="true"
                @reabrir-pale-confeccionado-en-punto-de-paletizado="ReabrirPaleConfeccionadoEnPuntoDePaletizado"
                @inicio-carga-datos="contadorDeLlamadasPendientesDeRespuestaEnFrm++"
                @fin-carga-datos="contadorDeLlamadasPendientesDeRespuestaEnFrm--"
              />
            </div>
            <!-- Ver Mas -->
            <div
              v-if="lineaSeleccionada != null && puntoDePaletizadoSeleccionado != null"
              class="div-verMas seleccionable"
            >
              <span
                class="span-verMas display-flex justify-content-center"
                @click="AbrirVerMasPalesDeComponentePCUltimosPalesGenerados()"
              >
                {{ $t('common.seeMore').toUpperCase() }}
              </span>
            </div>
          </div>
        </f7-col>
      </f7-row>
    </div>
    <!-- Boton flotante para finalizar palé mediante lectura de la ultima caja -->
    <PCFinPaleLecturaUltimaCaja
      :punto-paletizado-seleccionado="puntoDePaletizadoSeleccionado"
      :pedido-en-curso="pedidoEnCurso"
      :pale-en-curso-sin-planificar="paleEnCursoSinPlanificar"
      :configuracion-lectura-cajas="configuracionLecturaCajasFrmPaletizado"
      @pale-finalizado="PaleFinalizadoMedianteLecturaUltimaCaja"
    />

    <!-- Popup DetallePedidoSeleccionadoAbierto -->
    <f7-popup
      v-model:opened="popupDetallePedidoSeleccionadoAbierto"
      class="div-popupDetallePedidoSeleccionado"
    >
      <f7-page>
        <template #fixed>
          <f7-navbar
            :title="$t('production.common.salesOrderDetail')"
            sliding
            :style="appTheme"
          >
            <f7-nav-right>
              <f7-link
                class="margin-right"
                @click="popupDetallePedidoSeleccionadoAbierto = false"
              >
                <img :src="icClose">
              </f7-link>
            </f7-nav-right>
          </f7-navbar>
        </template>

        <template v-if="pedidoSeleccionado">
          <PCMensajesInformativosPlanificacion
            v-if="pedidoSeleccionado.MensajesInformacion != null && pedidoSeleccionado.MensajesInformacion.length > 0"
            :mensajes-informacion="pedidoSeleccionado.MensajesInformacion"
            @actualizar-cantidad-de-pales-planificados-con-la-cantidad-actual-pendiente-del-pedido="ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido()"
          />
          <PCDatosAuxiliaresLineaPedidoVenta
            v-if="mostrarDatosAuxiliaresLineaPedidoVenta"
            :activo="popupDetallePedidoSeleccionadoAbierto"
            :linea-pedido-venta=" { Id: pedidoSeleccionado.IdLineaPedidoVenta } "
          />

          <div class="order-details-card margin-top-half margin-horizontal-half">
            <div class="order-details-card-header">
              {{ `${$t('common.salesOrderShort').toUpperCase()}: ${pedidoSeleccionado.Pedido} ${pedidoSeleccionado.NombreCliente}` }}
            </div>

            <div class="order-details-card-info">
              <div class="order-details-card-info__title">
                <div class="order-details-card-info__title__title">
                  {{ pedidoSeleccionado.Producto.Nombre }}
                </div>
              </div>
              <div class="order-details-card-info__subtitle">
                {{ pedidoSeleccionado.Envase.Nombre }}
              </div>
              <div class="order-details-card-info__text">
                {{ `${pedidoSeleccionado.Pale.Codigo}-${FormatearCadena(pedidoSeleccionado.Pale.Nombre, 50)}` }}
              </div>
              <div class="order-details-card-info__footer">
                <div class="order-details-card-info__footer--items">
                  <div>
                    <img
                      width="26"
                      alt="iconPalet"
                      src="@/static/icons/ic_palet.svg"
                    >
                    <span>
                      {{ `${pedidoSeleccionado.CantidadPalet} ${$t('common.pallets').toLowerCase()}` }}
                    </span>
                  </div>
                  <div>
                    <img
                      width="26"
                      alt="iconBox"
                      src="@/static/icons/ic_box.svg"
                    >
                    <span>
                      {{ `${(pedidoSeleccionado.CantidadEnvasesPorPalet * pedidoSeleccionado.CantidadPalet)} ${$t('common.packages').toLowerCase()}` }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <f7-list
            accordion-list
            inset
            class="order-details-accordion margin-horizontal-half margin-top-half no-margin-bottom"
          >
            <f7-list-item
              accordion-item
              accordion-item-opened
              :title="$t('common.otherDataPl').toUpperCase()"
            >
              <f7-accordion-content>
                <PCDetalleLineaPedidoVenta
                  :pedido-seleccionado="pedidoSeleccionado"
                  :elementos-mostrar="[
                    'DireccionDeEnvio',
                    'ObservacionesPedidoVenta',
                    'ObservacionesLineaPedidoVenta',
                    'ObservacionesPorte',
                    'ReferenciaPedidoVenta',
                    'AliasCliente',
                    'Lote',
                    'UbicacionPalesProducidos',
                    'FechaSalida',
                  ]"
                />
              </f7-accordion-content>
            </f7-list-item>
          </f7-list>

          <f7-list
            v-if="datosComplementariosAObtener"
            accordion-list
            inset
            class="order-details-accordion margin-horizontal-half margin-top-half no-margin-bottom"
          >
            <f7-list-item
              accordion-item
              accordion-item-opened
              :title="$t('common.supplementaryData').toUpperCase()"
            >
              <f7-accordion-content>
                <UCSupplementaryData
                  :activo="popupDetallePedidoSeleccionadoAbierto"
                  :entidad-seleccionada="{ Id: pedidoSeleccionado.IdLineaPedidoVenta }"
                  tipo-entidad-seleccionada="LineaPedidoVenta"
                />
              </f7-accordion-content>
            </f7-list-item>
          </f7-list>

          <f7-list
            accordion-list
            inset
            class="order-details-accordion margin-horizontal-half margin-top-half no-margin-bottom"
          >
            <f7-list-item
              accordion-item
              accordion-item-opened
              :title="$t('production.palletizing.orderDetailsPopup.attachmentsData').toUpperCase()"
            >
              <f7-accordion-content>
                <PCDatosAdjuntosEntidad
                  :show-title="true"
                  :is-active="popupDetallePedidoSeleccionadoAbierto"
                  :entity-id="pedidoSeleccionado.IdPedidoVenta"
                  entity-type="PedidoVenta"
                />
              </f7-accordion-content>
            </f7-list-item>
          </f7-list>
        </template>
      </f7-page>
    </f7-popup>

    <!-- Popup Edición de Pedido Planificado -->
    <f7-popup
      class="edicionPedidoPlanificado-popup"
      :opened="popupEdicionPedidoPlanificadoAbierto"
      @popup:closed="popupEdicionPedidoPlanificadoAbierto = false"
    >
      <f7-navbar
        :title="$t('production.editPallet.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupEdicionPedidoPlanificadoAbierto = false">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>

      <FrmEditTypeOfPackaging
        :activo="popupEdicionPedidoPlanificadoAbierto"
        :mostrar-navbar-frm="false"
        @cerrar-frm="CerrarFrmEdicion()"
        @tipo-envasado-actualizado="TipoEnvasadoPaleActivoModificado()"
      />
    </f7-popup>

    <!-- Popup Nuevo Palé -->
    <f7-popup
      class="nuevoPale-popup"
      :opened="popupNuevoPaleSinPedidoPlanificado"
      @popup:closed="popupNuevoPaleSinPedidoPlanificado = false"
    >
      <f7-navbar
        :title="$t('production.newPallet.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link
            class="margin-right"
            @click="popupNuevoPaleSinPedidoPlanificado = false"
          >
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <FrmNewPalletWithoutPlannedOrder
        :activo="popupNuevoPaleSinPedidoPlanificado"
        :parent-theme="appTheme"
        :mostrar-navbar-frm="false"
        :partidas-activas="partidasActivas"
        @cerrar-frm="CerrarFrmNuevoPale()"
        @nuevo-pale-sin-pedido-planificado-generado="NuevoPaleSinPedidoPlanificadoGenerado()"
      />
    </f7-popup>
    <!-- Configuración del formulario Paletizado -->
    <f7-popup
      class="popup-ConfiguracionMultiPunto"
      :opened="popupConfiguracionPaletizado"
      @popup:closed="popupConfiguracionPaletizado = false"
    >
      <f7-navbar
        :title="$t('common.configuration')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupConfiguracionPaletizado = false">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div class="margin-left margin-top margin-bottom">
        <span class="span-texto-gris-14-500">
          {{ $t('common.configurationParameters') }}
        </span>
        <PCConfiguracionComunProcesosTA
          @close="popupConfiguracionPaletizado = false"
        />
      </div>
    </f7-popup>
    <!-- Configuración del Punto de Paletizado Seleccionado -->
    <f7-popup
      class="popup-ConfiguracionPuntoPaletizadoSeleccionado"
      :opened="popupConfiguracionPuntoPaletizadoSelecionado"
      @popup:closed="popupConfiguracionPuntoPaletizadoSelecionado = false"
    >
      <f7-navbar
        :title="$t('ConfiguracionPuntoPaletizado')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupConfiguracionPuntoPaletizadoSelecionado = false">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div class="margin-left margin-top margin-bottom">
        <span class="span-texto-gris-14-500">
          {{ $t('common.configurationParameters') }}
        </span>

        <PCConfiguracionPuntoPaletizado
          :activo="popupConfiguracionPuntoPaletizadoSelecionado"
          :app-theme="appTheme"
          :punto-paletizado="puntoDePaletizadoSeleccionado"
          @change="ConfiguracionPuntoPaletizadoSelecionadoModificada"
          @cerrar-frm="popupConfiguracionPuntoPaletizadoSelecionado = false"
        />
      </div>
    </f7-popup>

    <!-- Configuración Asignar cajas Pale en curso -->
    <f7-popup
      class="popup-asignacionCajasConPale hide-popup-scanner"
      :opened="popupAsignacionCajasPale"
      :close-by-backdrop-click="false"
      @popup:closed="CerrarPopupAsignacionCajasPale()"
    >
      <f7-navbar
        :title="$t('production.assignBoxesPallet.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <div v-if="puntoDePaletizadoSeleccionado != null">
            <div
              v-if="(configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarras || configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarrasManual) && configuracionLecturaRegistroActividadFrmPaletizado.LecturaContinuaCodigosBarras && puntoDePaletizadoSeleccionado.PermiteRegistroProductividadTrabajadores && cajasPendintesDeSinc.length > 0"
              class="margin-top-half"
              @click="SincronizarCajas"
            >
              <img
                src="@/static/icons/ic_refresh.svg"
                alt="iconSinc"
                width="38px"
              >
            </div>
            <!--
            <div
              class="margin-top-half"
              @click="AbrirScannerLecturaCajas"
            >
              <img
                src="@/static/icons/ic_qr.svg"
                alt="iconScan"
                width="38px"
              >
            </div>
          -->
          </div>
          <f7-link @click="CerraPopupConValidacion">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div class="">
        <PCLecturaEnvasesPale
          ref="PCLecturaEnvasesPale"
          :pedido-seleccionado="paleEnCursoSinPlanificarSeleccionado != null ? paleEnCursoSinPlanificarSeleccionado : pedidoSeleccionado"
          :total-envases="totalEnvases === 0 ? articuloAsignados : totalEnvases"
          :articulo-numero-serie="objANSEnCursoPuntoPaletizado"
          :cantidad-lecturas-continuas="cantidadLecturaContinuaReg"
          :configuracion-lectura-cajas="configuracionLecturaCajasFrmPaletizado"
          :configuracion-lectura-registro-act="configuracionLecturaRegistroActividadFrmPaletizado"
          :asignacion-registro-trabajadores="puntoDePaletizadoSeleccionado != null ? puntoDePaletizadoSeleccionado.PermiteRegistroProductividadTrabajadores : false"
          :comprobar-confeccion-caja="paleEnCursoSinPlanificar == null && pedidoEnCurso !== null"
          @editar-actividad-envase="EditarActividadPorEnvase"
          @pendientes-sinc="MostrarSincronizacion"
        />
      </div>
    </f7-popup>

    <!-- Registro actividad por envase -->
    <f7-popup
      class="popup-asignacionActividadPorEnvase hide-popup-scanner"
      :opened="popupAsignacionActividadPorEnvase"
      :close-by-backdrop-click="false"
      @popup:closed="CerrarPopupAsignacionActividadPorEnvase()"
    >
      <f7-navbar
        :title="$t('production.packagingActivityRecords.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupAsignacionActividadPorEnvase = false">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div class="">
        <PCRegistroActividadPorEnvase
          :cantidad-lecturas-continuas="cantidadLecturaContinuaReg"
          :articulo-elaborado="articuloElaboradoSelccionado"
          :articulo-numero-serie="objANSEnCursoPuntoPaletizado"
          :configuracion-lectura-registro-act="configuracionLecturaRegistroActividadFrmPaletizado"
          :configuracion-lectura-cajas="configuracionLecturaCajasFrmPaletizado"
          @lista-registros="AddRegistroActividadAE"
          @elemento-local-eliminado="RegistroLocalEliminado"
        />
      </div>
    </f7-popup>

    <!-- Action Confirmación Pedido con palés reservados -->
    <f7-actions
      id="actions-ConfirmarPedidoConPalesReservados"
      class="actions-1"
      :opened="actionConfirmarPedidoConPalesReservados"
      @actions:closed="actionConfirmarPedidoConPalesReservados = false"
    >
      <div v-if="actionConfirmarPedidoConPalesReservados">
        <div class="div-actionsTitulo-2">
          <span class="">
            {{ $t('production.palletizing.labels.reservedPallets') }}
          </span>
        </div>
        <f7-actions-label class="text-align-center">
          {{ valorMensajeDeConfirmacion }}
        </f7-actions-label>
        <div class="div-elementoSeparador-90" />

        <!-- Pie de  Boton Opciones -->
        <div class="div-opcionesActions">
          <f7-row>
            <f7-col
              width="50"
              class="col-izquierdaActions"
            >
              <a
                class="link link-izquierdaActions-1"
                @click="actionConfirmarPedidoConPalesReservados = false"
              >
                {{ $t('common.cancel').toUpperCase() }}
              </a>
            </f7-col>
            <f7-col
              width="50"
              class="col-derechaActions"
            >
              <a
                class="link link-derechaActions-1"
                @click="IniciarPedido(pedidoSeleccionado, false, false);actionConfirmarPedidoConPalesReservados = false"
              >
                {{ $t('common.continue').toUpperCase() }}
              </a>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </f7-actions>
    <f7-actions
      class="content-action-sheet-incidencias"
      :opened="articlesActionsOpened"
      @actions:closed="articlesActionsOpened = false"
    >
      <f7-block>
        <div>
          <!-- Seleccion de articulo para cambio de variedad -->
          <div>
            <div class="content-action-sheet-incidencias__search text-align-center">
              <UCSearchEntityERP
                :title="$t('common.articles')"
                :placeholder="$t('searchEntity.article.placeholder.selectAnArticle')"
                :search-text="$t('searchEntity.article.searchText')"
                :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
                :min-text-search="0"
                :property-entity-shown-input="['Nombre', 'Codigo']"
                :emit-evet-change-default-value="true"
                :default-value="articulosVolcasoALPV != null ? articulosVolcasoALPV[0] : null"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :default-etities-list="articulosVolcasoALPV != null ? articulosVolcasoALPV : null"
                @open-popup-search-entities="articlesActionsOpened = false"
                @close-popup-search-entities="articlesActionsOpened = true"
                @selection="(value) => articuloSelecctionadoEdit = value"
              />
            </div>
          </div>
          <div>
            <span>
              {{ $t('production.palletizing.info.selectVarietyForPallet') }}
            </span>
          </div>
          <div class="content-action-sheet-incidencias__buttons">
            <a
              class="color-red"
              @click="articlesActionsOpened = false"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
            <a
              class="color-blue"
              @click="EditarTipoEnvasado"
            >
              {{ $t('common.confirm').toUpperCase() }}
            </a>
          </div>
        </div>
      </f7-block>
    </f7-actions>

    <f7-popup
      class="nfcScann-popup"
      :opened="popupTagNFCRequired"
      @popup:closed="popupTagNFCRequired = false"
    >
      <f7-navbar
        :title="$t('TagNFCRequired')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link
            @click="popupTagNFCRequired = false"
          >
            <img
              :src="icClose"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div class="img-nfc">
        <img
          src="@/static/icons/NFC.svg"
        >
        <div>
          <form
            class="from-busquedasCodigoBarras display-flex flex-direction-column"
            @submit.prevent="EventLecturaDeTagNFC(valorCampoLectura)"
          >
            <div class="div-input">
              <input
                id="codigoBarras"
                class="input-searchCodeBars"
                :label="$t('common.barcode')"
                type="text"
                :placeholder="$t('common.barcode')"
                clear-button
                :value="valorCampoLectura"
                @input="valorCampoLectura = $event.target.value"
              >
            </div>
          </form>
        </div>
        <UCLectorNFC
          :show-logo="false"
          :active="popupTagNFCRequired"
          @nfc-scan="EventLecturaDeTagNFC"
        />
      </div>
    </f7-popup>
    <f7-popup
      class="content-origin-data-asignation-popup"
      :opened="popupAsignacionDatosOrigen"
      @popup:closed="popupAsignacionDatosOrigen = false;"
      @popup:open="$refs.PCAsignacionDatosOrigen.Conections_GetOriginPallet()"
    >
      <f7-page class="page-pcAsignacionDatosOrigen">
        <TheNavbar
          :nav-title="$t('production.assignOriginData.title')"
          :back-btn-enable="false"
          :style="appTheme"
          add-btn-enable
          @add-btn="$refs.PCAsignacionDatosOrigen.AbrirPalesVolcados()"
        >
          <template #btn-right>
            <img
              src="@/static/icons/ic_qr.svg"
              class="padding-left-half"
              @click="$refs.PCAsignacionDatosOrigen.OpenCodeSearch()"
            >
          </template>
        </TheNavbar>
        <PCAsignacionDatosOrigen
          v-if="paleEnCurso !== null"
          ref="PCAsignacionDatosOrigen"
          :titulo="paleEnCurso ? paleEnCurso.NumeroSerie : ''"
          :subtitulo="paleEnCurso ? paleEnCurso.NombreProducto : ''"
          :text="pedidoEnCurso != null ? pedidoEnCurso.Envase.Nombre : (paleEnCursoSinPlanificar != null ? paleEnCursoSinPlanificar.Envase.Nombre : '')"
          :articulos-asignados="articuloAsignados"
          :producto-pale-en-curso="productoPaleEnCurso"
          :total-envases="totalEnvases === 0 ? articuloAsignados : totalEnvases"
        />
        <div class="content-origin-data-asignation-popup__buttons">
          <div class="content-buttons-origin-data-asignation">
            <f7-button
              class="button-reject"
              @click="CancelButtonClickOriginData"
            >
              {{ $t('common.cancel') }}
            </f7-button>
            <f7-button
              class="button-confirm"
              @click="ConfirmButtonClickOriginData"
            >
              {{ $t('common.confirm') }}
            </f7-button>
          </div>
        </div>
      </f7-page>
    </f7-popup>

    <PCSistemaPesado
      :open-weighing-reading="actionsWeighingReading"
      :weight="weight"
      :id-a-n-s="idUltimoPale"
      @event-close="actionsWeighingReading = false"
      @update-weight="actionsWeighingReading = false"
    />

    <!-- Mensajes de Confirmación Genéricos. -->
    <UCConfirmation ref="UCConfirmation" />
    <UCConfirmation ref="componenteConfirmacionArticulosPendientes" />
    <!-- lector nfc -->
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import { VueDraggableNext } from 'vue-draggable-next';
import PCDatosAuxiliaresLineaPedidoVenta from '@/components/production/traceability/PCDatosAuxiliaresLineaPedidoVenta.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus'; // Import the EventBus.
import {
  HiDialog,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { LOGO_HISPATEC } from '@/js/common/constants';
import ConexionTA, {
  callCambiarOrdenPedidosPlanificados,
  callObtenerPedidosPlanificadosPuntoDePaletizado,
} from '@/js/services/traceability/APITraceability';
// import conexion from '@/js/services/traceability/conexionAPI';
import PCPartidasActivasYRecientesLinea from '@/components/production/traceability/PCPartidasActivasYRecientesLinea.vue';
import PCUltimosPalesGenerados from '@/components/production/traceability/PCUltimosPalesGenerados.vue';
import PCConfiguracionComunProcesosTA from '@/components/production/traceability/PCConfiguracionComunProcesosTA.vue';
import PCDetalleLineaPedidoVenta from '@/components/production/traceability/PCDetalleLineaPedidoVenta.vue';
import PCMensajesInformativosPlanificacion from '@/components/production/traceability/PCMensajesInformativosPlanificacion.vue';
import FrmEditTypeOfPackaging from '@/pages/production/traceability/palletizing/FrmLineItemEditing.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import FrmNewPalletWithoutPlannedOrder from '@/pages/production/traceability/palletizing/FrmNewPalletWithoutPlannedOrder.vue';
import PCFinPaleLecturaUltimaCaja from '@/components/production/traceability/PCFinPaleLecturaUltimaCaja.vue';
import PCConfiguracionPuntoPaletizado from '@/components/production/traceability/PCConfiguracionPuntoPaletizado.vue';
import PCLecturaEnvasesPale from '@/components/production/traceability/PCLecturaEnvasesPale.vue';
import PCRegistroActividadPorEnvase from '@/components/production/traceability/PCRegistroActividadPorEnvase.vue';
import { sleep } from '@/js/utils/sleep';
import SoporteCadena from '@/js/common/HiChainSupport';
import SoporteNumeracion from '@/js/common/HiNumerationSupport';
import SoportePersonalizacion from '@/js/services/soportePersonalizacion';
import PCDatosAdjuntosEntidad from '@/components/production/traceability/PCDatosAdjuntosEntidad.vue';
import PCOperacionesPersonalizadas from '@/components/production/traceability/PCOperacionesPersonalizadas.vue';
import UCSupplementaryData from '@/components/common/UCSupplementaryData.vue';
import icClose from '@/static/icons/ic_close.svg';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { callExecuteSPERP } from '@/js/services/APIErp';
import UCLectorNFC from '@/components/common/UCLectorNFC.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import PCAsignacionDatosOrigen from '@/components/production/traceability/PCAsignacionDatosOrigen.vue';
import PCSideNavbar from '@/components/common/PCSideNavbar.vue';
import PCSistemaPesado from '@/components/production/traceability/PCSistemaPesado.vue';
import { TipoFinPaletPuntoPaletizado } from '@/js/services/traceability/enumeradosTA';
import { f7 } from 'framework7-vue';
import { useSortedProductionLines } from '@/composables/useSortedProductionLines';

/** @import { ElementoPaleEnProduccion, Partida } from '@erpagroapp/types' */
/** @import { SideNavbarItem } from '@/composables/useSideNavbar' */

export default {
  name: 'FrmPalletizingHome',
  components: {
    UCSearchEntityERP,
    PCPartidasActivasYRecientesLinea,
    PCDetalleLineaPedidoVenta,
    PCSideNavbar,
    PCUltimosPalesGenerados,
    FrmEditTypeOfPackaging,
    FrmNewPalletWithoutPlannedOrder,
    UCPreload,
    VueDraggableNext,
    PCConfiguracionComunProcesosTA,
    UCConfirmation,
    PCMensajesInformativosPlanificacion,
    PCDatosAdjuntosEntidad,
    PCFinPaleLecturaUltimaCaja,
    PCConfiguracionPuntoPaletizado,
    PCLecturaEnvasesPale,
    PCRegistroActividadPorEnvase,
    PCDatosAuxiliaresLineaPedidoVenta,
    PCOperacionesPersonalizadas,
    UCSupplementaryData,
    UCLectorNFC,
    TheNavbar,
    PCAsignacionDatosOrigen,
    PCSistemaPesado,

  },

  setup() {
    const { sortedProductionLines } = useSortedProductionLines();
    return {
      sortedProductionLines,
    };
  },

  data() {
    return {
      lineaSeleccionada: null, // Mantiene la linea seleccionada.
      puntosDePaletizado: null, // Mantiene los puntos de paletizado de la linea de produccion selecctionada.
      listadoPedidosPlanificados: null, // Mantiene los pedidos planificados.
      pedidoEnCurso: null, // Mantiene el pedido en curso.
      pedidoSeleccionado: null, // Mantiene el pedido seleccionado o el pedido sobre el que se realizo el último cambio.
      paleEnCursoSinPlanificar: null, // Mantiene el Palé en curso activo y que no esta planificado como pedido.
      paleEnCursoSinPlanificarSeleccionado: null, // Si se selecciona el paleEnCursoSinPlanificar
      drag: false, // Controla cuando se esta arrastrando un componente de la lista.
      popupEdicionPedidoPlanificadoAbierto: false, // Controla la apertura del popup.
      popupNuevoPaleSinPedidoPlanificado: false, // Controla la apertura del popup para generar nuevos pales sin asignar a pedidos.
      popupDetallePedidoSeleccionadoAbierto: false,
      actionConfirmarPedidoConPalesReservados: false,
      // actionConfirmarEliminarPaleEnCursoEnPuntoPaletizado: false,
      // actionConfirmarInicioPaleSinPartidaDeFamiliaActiva: false,
      habilitarEdicion: false, // Controla si se habilita el boton de editar (solo si el pedido seleccionado esta en curso o hay un paleEnCurso seleccionado)
      mostrarPrecarga: false,
      lineaSeleccionadaAlIniciarFormulario: null, // Mantiene la ultima linea seleccionada en este o otros frm para que cuando se abra el frm carge la ultima.
      valorMensajeDeConfirmacion: '', // Mantiene el valor del ultimo mensaje de confirmación
      verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido: false, // Si se establece a true antes de iniciar un nuevo palé en un pedido se verificara el número de reservas de pales de la linea de pedido.
      nombreFrmPCUltimosPalesGenerados: 'Palés Generados',
      paleReabiertoEnPuntoDePaletizado: null, // Contendra los palés reabiertos.
      contadorDeLlamadasPendientesDeRespuestaEnFrm: 0, // Controla el número de llamadas al WS que se estan realizando en el frm sin respuesta.
      popupConfiguracionPaletizado: false,
      mostrarPrecargaPaleActivo: false,
      popupConfiguracionPuntoPaletizadoSelecionado: false,
      popupAsignacionCajasPale: false,
      popupAsignacionActividadPorEnvase: false,
      objANSEnCursoPuntoPaletizado: null,
      /** @type {Partida[]} */
      partidasActivas: [], // Partidas activas del punto paletizado seleccionado.
      icClose,
      datosLineasPedidoParaPersonalizaciones: [], // Contiene un listado de los datos de las lineas de pedido visualizadas para ser utilizado en la consulta de personalizaciones
      personalizacionPCTarjetaPlanificacionActiva: false, // Controla si estan activas las personalizaciones en las tarjetas de planificación
      personalizacionPuntoPalrtizadoActiva: false, // Controla si estan activas las personalizaciones en los puntos de paletizado
      articulosVolcasoALPV: null,
      articuloSelecctionadoEdit: null,
      popupTagNFCRequired: false, // Controla la apertura del popup para solicitar la lectura de un tag NFC para finalizar el pale
      ultimoProcesoFin: '', // Ultimo proceso de finalizacion utilizado para el proceso de asignacion del tag nfc FinalizarPalePlanificado FPP FinalizarPaleEnCursoNoPlanificado FPNP
      tagAsignadoCorrectamente: false,
      valorCampoLectura: '', // valor input nfc
      totalEnvases: 0, // cantdad de emvases a mostrar en caso de que sea fin de bulto a bulto
      articuloAsignados: 0, // cantidad de cajas asignadas al pale si es fin de bulto a bulto
      /**
       * Temporizador de actualizaciones.
       * @type {ReturnType<typeof setTimeout> | null}
       */
      updateTimer: null,
      automaticUpdateInterval: 30, // Tiempo en segundos para actualizar
      dragOptions: { draggable: '.movible' },
      popupAsignacionDatosOrigen: false,
      elementoPaleEnProduccion: {},
      lineasProduccion: null,
      articuloElaboradoSelccionado: null,
      cantidadLecturaContinuaReg: 0, // guarda el valor del dato complementario designaqdo para la repiticion de lecutras si PermiteRegistroProductividadTrabajadores esta activo
      cajasPendintesDeSinc: [],
      actionsWeighingReading: false,
      weight: 0, // Peso del palé en curso
      idUltimoPale: 0,
      /** Whether the articles actions should be opened. */
      articlesActionsOpened: false,
      permitirFinPaleLecturaUltimaCaja: false,
      LOGO_HISPATEC,
      datosComplementariosAObtener: useParamRef('DatosComplementariosAObtener'),
      mostrarDatosAuxiliaresLineaPedidoVenta: useParamRef('mostrarDatosAuxiliaresLineaPedidoVenta'),
      bloquearFinPaletSinDatosOrigen: useParamRef('BloquearFinPaletSinDatosOrigen'),
      actualizarConfeccionPrevistaFamiliaGenericaPedido: useParamRef('ActualizarConfeccionPrevistaFamiliaGenericaPedido'),
      noMostrarEnvasesConfeccionadosUIC: useParamRef('NoMostrarEnvasesConfeccionadosUIC'),
      logoApp: useSettingRef('App.Logo'),
      activePalletSettings: {
        view: useSettingRef('Paletizado.PaleActivo.MostrarInformacion'),
        showSalesOrder: useSettingRef('Paletizado.PaleActivo.MostrarPedidoVenta'),
        showCustomerName: useSettingRef('Paletizado.PaleActivo.MostrarNombreCliente'),
        showSerialNumber: useSettingRef('Paletizado.PaleActivo.MostrarNumeroSerie'),
        showProduct: useSettingRef('Paletizado.PaleActivo.MostrarProducto'),
        showPackage: useSettingRef('Paletizado.PaleActivo.MostrarEnvase'),
        showPallet: useSettingRef('Paletizado.PaleActivo.MostrarPale'),
        showPackagesPerPallet: useSettingRef('Paletizado.PaleActivo.MostrarEnvasesPorPale'),
      },
      imprimirEtiquetaFinPale: useSettingRef('Paletizado.FinPale.ImprimirEtiqueta'),
      pesajeFinPale: useSettingRef('Paletizado.FinPale.Pesaje'),
      filtrarAlertasYNotificacionesPorLineaYPuntoDePaletizadoSeleccionado: useSettingRef(
        'Trazabilidad.Alertas.FiltrarPorLineaYPuntoPaletizadoSeleccionado',
      ),
      mostrarAlertasYNotificacionesDePedidosModificados: useSettingRef(
        'Trazabilidad.Alertas.MostrarAlertasPedidosModificados',
      ),
      mostrarAlertasYNotificacionesDePlanificacionesYDesplanificaciones: useSettingRef(
        'Trazabilidad.Alertas.PlanificacionesYDesplanificaciones',
      ),
      configuracionLecturaCajasFrmPaletizado: {
        LecturaContinuaCodigosBarras: useSettingRef('Paletizado.LecturaCajas.LecturaContinuaCodigosBarras'),
        LecturaContinuaCodigosBarrasManual: useSettingRef('Paletizado.LecturaCajas.LecturaContinuaCodigosBarrasManual'),
        UtilizarFlash: useSettingRef('Paletizado.LecturaCajas.UtilizarFlash'),
        OrientacionCamaraLecturaCodigos: useSettingRef('Paletizado.LecturaCajas.OrientacionCamaraLecturaCodigos'),
      },
      configuracionLecturaRegistroActividadFrmPaletizado: {
        LecturaContinuaCodigosBarras: useSettingRef('Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarras'),
        LecturaContinuaCodigosBarrasManual: useSettingRef('Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarrasManual'),
        UtilizarFlash: useSettingRef('Paletizado.LecturaRegistroActividad.UtilizarFlash'),
        OrientacionCamaraLecturaCodigos: useSettingRef('Paletizado.LecturaRegistroActividad.OrientacionCamaraLecturaCodigos'),
      },
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'lineasDeProduccionDelUsuarioDefinidaEnERP',
      'paleEnCurso',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'lineaDeProduccionSeleccionada',
      'tipoEnvasadoElementoProduccionSeleccionado',
      'puntoDePaletizadoSeleccionado',
      'familiaArticuloSeleccionada',
      'pedidoPlanificadoSeleccionado',
      'edicionPaleSinPedido',
      'criteriosDeBusquedaParaAlertasNotificacionDelUsuario',
      'paleEnCurso',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    habilitarRegistroProductividadTrabajadores() {
      if (this.puntoDePaletizadoSeleccionado !== null
        && (this.puntoDePaletizadoSeleccionado.PermiteRegistroProductividadTrabajadores
          || (this.puntoDePaletizadoSeleccionado.UtilizarUIC
            && this.puntoDePaletizadoSeleccionado.TipoFinPalet === TipoFinPaletPuntoPaletizado.ManualLecturaBultoABulto))
            && this.habilitarEdicion
      ) {
        return true;
      }
      return false;
    }, /*
    trabajarConAsignacionDePartidasPorPedido() {
      if (this.lineaSeleccionada !== null
      && this.lineaSeleccionada.AsignarDatosOrigenPorPedido
      ) { return true; }
      return false;
    },
    */
    productoPaleEnCurso() {
      return (
        this.pedidoSeleccionado?.TipoEnvasadoElementoProduccion?.Articulo
        || this.pedidoSeleccionado?.Producto
        || this.paleEnCursoSinPlanificarSeleccionado?.Producto
        || null
      );
    },
  },
  watch: {
    contadorDeLlamadasPendientesDeRespuestaEnFrm(val) {
      if (val === 0) {
        this.ActualizarNumeroAlertasYNotificaciones(); // Cuando esta cargado todo actualizamos las alertas.
      }
      if (val < 0) {
        this.contadorDeLlamadasPendientesDeRespuestaEnFrm = 0;
      } // El contador no puede ser negativo
    },
    listadoPedidosPlanificados(val) {
      if (val !== null && val.length > 0) {
        this.ObtenerPersonalizacionesPlanificaciones(val);
      }
    },

  },
  mounted() {
    this.IncializarFrm();
  },

  unmounted() {
    this.RemoveIntervalAutomaticUpdates();
  },

  methods: {
    IncializarFrm() {
      Log(this, this.IncializarFrm.name);
      // Sol.221815  - Cuando salgo para volcar y vuelvo a entrar en el paletizado, debe seguir cargada la última línea que estuvo seleccionada.
      this.lineaSeleccionadaAlIniciarFormulario = this.lineaDeProduccionSeleccionada;
      this.lineaSeleccionada = this.lineaDeProduccionSeleccionada;
      // sol.222038 - Si lineaSeleccionadaAlIniciarFormulario es null obtenemos la linea por defecto definida en el trabajador.
      if (this.lineaSeleccionadaAlIniciarFormulario == null) {
        this.lineaSeleccionadaAlIniciarFormulario = this.lineasDeProduccionDelUsuarioDefinidaEnERP;
        this.lineaSeleccionada = this.lineasDeProduccionDelUsuarioDefinidaEnERP;
      }
      this.lineaDeProduccionSeleccionada = this.lineaSeleccionada;
      this.ConfigurarPersonalizacionesFrm();
      this.lineasProduccion = this.sortedProductionLines;

      this.SetIntervalAutomaticUpdates();
    },

    RestablecerListasDePedidosYPales() {
      Log(this, this.RestablecerListasDePedidosYPales.name);
      this.listadoPedidosPlanificados = null;
      this.pedidoEnCurso = null;
      this.pedidoSeleccionado = null;
      this.paleEnCursoSinPlanificar = null;
      this.paleEnCursoSinPlanificarSeleccionado = null;
      this.paleReabiertoEnPuntoDePaletizado = null;
      this.habilitarEdicion = false;
    },

    /* Actualizar info cajas cargadas* */
    SetIntervalAutomaticUpdates() {
      Log(this, this.SetIntervalAutomaticUpdates.name);

      this.updateTimer = setInterval(() => {
        this.UpdateQuantity();
      }, this.automaticUpdateInterval * 1000);
    },

    /** Method RemoveIntervalAutomaticUpdates  */
    RemoveIntervalAutomaticUpdates() {
      Log(this, this.RemoveIntervalAutomaticUpdates.name);

      if (this.updateTimer) {
        clearInterval(this.updateTimer);
        this.updateTimer = null;
      }
    },

    async UpdateQuantity() {
      Log(this, this.UpdateQuantity.name);

      if (!this.puntoDePaletizadoSeleccionado
        || !this.puntoDePaletizadoSeleccionado.UtilizarUIC
        || this.puntoDePaletizadoSeleccionado.TipoFinPalet === TipoFinPaletPuntoPaletizado.ManualLecturaUltimoBulto
        || this.puntoDePaletizadoSeleccionado.TipoFinPalet === TipoFinPaletPuntoPaletizado.ManualLecturaUltimoBultoReservado
      ) {
        return;
      }

      const result = await ConexionTA.callEnvasesAsignadosAlPaleEnCursoPorPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id);
      if (result.Valor) {
        const resJSON = result.Tag;
        this.totalEnvases = Number.parseInt(resJSON.PuntoPaletizadoRegistro.Cantidad, 10);
        this.articuloAsignados = resJSON.ArticuloElaborado.length;
      }

      if (this.listadoPedidosPlanificados && !this.noMostrarEnvasesConfeccionadosUIC) {
        this.ArticulosElaboradosXLineasPedidoVenta();
      }
    },

    ConfigurarPersonalizacionesFrm() {
      this.personalizacionPCTarjetaPlanificacionActiva = SoportePersonalizacion.ExistePersonalizacion('frmPaletizado', 'PCTarjetaPlanificacion');
      this.personalizacionPuntoPalrtizadoActiva = SoportePersonalizacion.ExistePersonalizacion('frmPaletizado', 'PCSelectorPuntoPaletizado');
    },

    async ObtenerPersonalizacionesPlanificaciones(lstPlanificaciones) {
      if (!this.personalizacionPCTarjetaPlanificacionActiva) {
        return;
      } // Comprueba si esta activa.
      this.datosLineasPedidoParaPersonalizaciones = [];
      const entidades = [];
      const arrayLstPlanificaciones = lstPlanificaciones.map((i) => [i.IdLineaPedidoVenta, i]);

      const mapPlanificaciones = new Map(arrayLstPlanificaciones);

      const lstPlanificacionesUnicos = [...mapPlanificaciones.values()];

      lstPlanificacionesUnicos.forEach((e) => {
        entidades.push({ Id: e.IdLineaPedidoVenta });
      });
      this.datosLineasPedidoParaPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'frmPaletizado', 'PCTarjetaPlanificacion');
    },

    LineaProduccionSeleccionada(lineaSeleccionada) {
      Log(this, this.LineaProduccionSeleccionada.name);
      if (lineaSeleccionada != null) {
        this.lineaDeProduccionSeleccionada = lineaSeleccionada;

        if (lineaSeleccionada.DispositivoBaseDatos !== null) {
          const puntosPaletizado = [];
          if (lineaSeleccionada.PuntosDePaletizado != null) {
            lineaSeleccionada.PuntosDePaletizado.forEach((p) => {
              if (p.UsoEnIntegracion) {
                puntosPaletizado.push(p);
              }
            });

            lineaSeleccionada.PuntosDePaletizado = puntosPaletizado;
          }
        }
      }
      this.RestablecerListasDePedidosYPales();
      this.lineaSeleccionada = lineaSeleccionada;
      if (this.$refs.componentePCPartidasActivasYRecientesLinea != null) {
        this.$refs.componentePCPartidasActivasYRecientesLinea.RestablecerValores();
      }
      this.$refs.componentePCUltimosPalesGenerados.RestablecerValores();
      this.EliminarFiltrosDeAlertasParaLosPedidosMostrados();
      if (lineaSeleccionada == null) {
        this.puntosDePaletizado = null;
        this.puntoDePaletizadoSeleccionado = null;
        return;
      }
      this.puntosDePaletizado = [...this.lineaSeleccionada.PuntosDePaletizado];
      if (this.puntosDePaletizado != null && this.puntosDePaletizado.length > 0) {
        this.PuntoDePaletizadoSeleccionado(this.puntosDePaletizado[0]); // Por defecto se selecciona el primer punto de paletizado.
        this.EstablecerPalesActivosPuntosPaletizado();
      } else {
        this.PuntoDePaletizadoSeleccionado(null);
        HiNotification.Toast(this.$t('production.palletizing.info.lineHasNoPalletizingPoints'));
      }
      this.UpdateQuantity();
    },

    async EstablecerPalesActivosPuntosPaletizado() {
      try {
        const idsPuntosPaletizado = this.puntosDePaletizado.map((p) => p.Id).join(',');
        const { data } = await ConexionTA.FetchActivePalletsXPalletizingPoint(idsPuntosPaletizado);

        if (Array.isArray(data)) {
          for (const punto of this.puntosDePaletizado) {
            const paleActivo = data.find((p) => punto.Id === p.PuntoPaletizadoRegistro.PuntoPaletizado.Id);
            punto.PaleActivo = paleActivo || null;
          }
        }
      } catch (error) {
        LogError(this, this.EstablecerPalesActivosPuntosPaletizado.name, error);
      }
    },

    async EstablecerPalesActivosPuntoPaletizado(idPuntoPaletizado) {
      const punto = this.puntosDePaletizado.find((p) => p.Id === idPuntoPaletizado);

      if (punto) {
        try {
          const { data } = await ConexionTA.FetchActivePalletsXPalletizingPoint(idPuntoPaletizado);

          if (Array.isArray(data) && data.length === 1) {
            [punto.PaleActivo] = data;
          }
        } catch (error) {
          LogError(this, this.EstablecerPalesActivosPuntosPaletizado.name, error);
        }
      }
    },

    /**
     * @param {ElementoPaleEnProduccion} paleActivo
     * @returns {string | null}
     */
    GetSalesOrderTextForActivePallet(paleActivo) {
      const salesOrderLine = paleActivo.InformacionPedidoOrigen?.LineaPedidoVenta;
      const salesOrder = salesOrderLine?.PedidoVenta;
      if (!salesOrder) {
        return null;
      }

      return `${salesOrder.Serie ?? ''}/${salesOrder.Numero}-${salesOrderLine.Orden}`;
    },

    /**
     * @param {ElementoPaleEnProduccion} paleActivo
     * @returns {string | null}
     */
    GetCustomerNameTextForActivePallet(paleActivo) {
      return paleActivo.InformacionPedidoOrigen?.LineaPedidoVenta?.PedidoVenta?.Cliente?.Sujeto?.Nombre
        ?? null;
    },

    PermitirFinPaleLecturaUltimaCaja() {
      this.permitirFinPaleLecturaUltimaCaja = this.puntoDePaletizadoSeleccionado.UtilizarUIC && (this.puntoDePaletizadoSeleccionado.TipoFinPalet === TipoFinPaletPuntoPaletizado.ManualLecturaUltimoBulto
        || this.puntoDePaletizadoSeleccionado.TipoFinPalet === TipoFinPaletPuntoPaletizado.ManualLecturaUltimoBultoReservado) && (this.pedidoEnCurso != null || this.paleEnCursoSinPlanificar != null);
    },

    PuntoDePaletizadoSeleccionado(puntoSeleccionado) {
      Log(this, this.PuntoDePaletizadoSeleccionado.name);
      this.puntoDePaletizadoSeleccionado = puntoSeleccionado; // Variable Comun
      this.RestablecerListasDePedidosYPales();
      this.$refs.componentePCUltimosPalesGenerados.RestablecerValores();
      this.EliminarFiltrosDeAlertasParaLosPedidosMostrados();
      if (puntoSeleccionado == null) {
        return;
      }
      this.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
      if (this.$refs.componentePCPartidasActivasYRecientesLinea != null) {
        this.$refs.componentePCPartidasActivasYRecientesLinea.ActualizarDatos();
      }
      this.ObtenerTodosLosPedidosPlanificadosDeLaLinea();
      this.UpdateQuantity();
    },

    SeleccionarPaleEnCursoNoPlanificado() {
      Log(this, this.SeleccionarPaleEnCursoNoPlanificado.name);
      if (this.puntoDePaletizadoSeleccionado.UsoEnIntegracion) {
        HiNotification.Toast(this.$t('production.palletizing.info.palletizingPointInIntegrationProcess'));
        return;
      }
      this.paleEnCursoSinPlanificarSeleccionado = this.paleEnCursoSinPlanificar;
      if (this.puntoDePaletizadoSeleccionado.PermiteRegistroProductividadTrabajadores) {
        this.ObtenerDatoComplementarioNACxEnvase(this.paleEnCursoSinPlanificarSeleccionado.Envase.Id);
      }
      this.pedidoSeleccionado = null;
      this.habilitarEdicion = true;
    },

    ConsultarSiExisteUnPaleEnCurso() {
      if (this.paleEnCursoSinPlanificar != null) {
        return true;
      }
      if (this.listadoPedidosPlanificados == null || this.listadoPedidosPlanificados.length === 0) {
        return false;
      }
      if (this.listadoPedidosPlanificados.find((p) => p.TipoEstado === 1) !== undefined) {
        return true;
      }
      return false;
    },

    IniciarPedido(pedidoSeleccionado, verificarReservas, verificarPartidaActivaMismaFamilia) {
      Log(this, this.IniciarPedido.name);
      this.pedidoSeleccionado = pedidoSeleccionado;

      if (this.listadoPedidosPlanificados.find((p) => p.TipoEstado === 1) !== undefined) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToFinishCurrentOrder'));
        return;
      }
      // Comprobamos que el pedido este planificado el primero para poder inicializarlo.
      if (this.listadoPedidosPlanificados.findIndex((p) => p.IdLineaPedidoVenta === pedidoSeleccionado.IdLineaPedidoVenta && p.IdPedidoVenta === pedidoSeleccionado.IdPedidoVenta) !== 0) {
        HiNotification.Toast(this.$t('production.palletizing.info.orderMustHaveHigherOrder'));
        return;
      }

      // Comprobamos que pedidoSeleccionado tiene un pedido.
      if (this.pedidoSeleccionado === null || this.pedidoSeleccionado === undefined) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectOrderToStart'));
        return;
      }
      // Verificamos que exista una partida activa de la misma familia
      if (verificarPartidaActivaMismaFamilia && !this.VerificarExistePartidaActivaParaFamilia(this.pedidoSeleccionado.Producto.Familia)) {
        this.$refs.UCConfirmation.create(
          this.$t('production.palletizing.noActiveBatchFamily.title').toUpperCase(),
          this.$t('production.palletizing.noActiveBatchFamily.text'),
          () => {
            this.IniciarPedido(pedidoSeleccionado, true, false);
          },
        );
        this.$refs.UCConfirmation.show();
        return;
      }

      const self = this;
      // Comprobamos si se solicita verificar reservas.
      self.verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido = verificarReservas;
      this.IniciarPale().then(() => {
        self.ActualizarPlanificadoYPartidasYPalesGenerados();
        self.EstablecerPalesActivosPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id);
      })
        .catch((result) => {
          // El palé no se inicio, verificamos que el tipo de error por si es necesaria alguna confirmación
          // por parte del usuario antes de iniciar el palé.
          if (result.Codigo === 301) {
            self.valorMensajeDeConfirmacion = result.Mensaje;
            self.actionConfirmarPedidoConPalesReservados = true;
          } else {
            // Cualquier otro mensaje de error lo mostramos.
            HiNotification.Toast(result.Mensaje);
          }
        })
        .finally(() => {
          // Desactivamos el verificado de reservas de la lineaPedido.
          // Por si otro proceso utiliza el IniciarPale
          self.verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido = false;
          this.PermitirFinPaleLecturaUltimaCaja();
        });
    },

    VerificarExistePartidaActivaParaFamilia(objFamiliaProducto) {
      Log(this, this.VerificarExistePartidaActivaParaFamilia.name);
      try {
        let tempListPartidasActivasDeLaFamiliaBuscada = [];
        // Si la familia es la misma.
        tempListPartidasActivasDeLaFamiliaBuscada = this.partidasActivas.filter((p) => p.Articulo.Familia.Id === objFamiliaProducto.Id);
        if (tempListPartidasActivasDeLaFamiliaBuscada.length > 0) {
          return true;
        }
        // Si la familia no es la misma comparamos con la de nivel superior.
        tempListPartidasActivasDeLaFamiliaBuscada = this.partidasActivas.filter((p) => p.Articulo.Familia.FamiliaNivelSuperior.Id === objFamiliaProducto.FamiliaNivelSuperior.Id && p.Articulo.Familia.FamiliaNivelSuperior.EsFiltroEnAsignacionPartidasOrigenTrazabilidad === objFamiliaProducto.FamiliaNivelSuperior.EsFiltroEnAsignacionPartidasOrigenTrazabilidad);
        if (tempListPartidasActivasDeLaFamiliaBuscada.length > 0) {
          return true;
        }
        // No hay partidas activas del producto del que se quiere iniciar el palé (mostramos mensaje)
        return false;
      } catch (error) {
        LogError(this, this.VerificarExistePartidaActivaParaFamilia.name, error);
        return true; // Continuamos.
      }
    },
    async FinalizarPalePlanificadoConCambioVariedad(pedidoSeleccionado) {
      Log(this, this.FinalizarPalePlanificadoConCambioVariedad.name);
      PreloaderGH(true, true, this.$t('production.palletizing.finishWithChangeOfVariety.preloaderText'));

      const famGenSinFormulacion = await this.ArticuloTieneFamiliaGenericaYSinFormulacion();
      if (famGenSinFormulacion.length > 0) {
        const articulosVolcadosAsociados = await this.ArticulosVolcadosAsociadosAlpv();
        PreloaderGH(false);
        if (articulosVolcadosAsociados.length < 1) {
          HiNotification.Alert(this.$t('production.palletizing.finishWithChangeOfVariety.noArticlesDumped'), this.$t('common.error'));
          return;
        }
        if (articulosVolcadosAsociados.length === 1) {
          this.FinalizarPalePlanificado(pedidoSeleccionado, !pedidoSeleccionado.PaleReabierto, false);
        }
        if (articulosVolcadosAsociados.length > 1) {
          this.articulosVolcasoALPV = articulosVolcadosAsociados;
          this.articlesActionsOpened = true;
        }
      } else {
        PreloaderGH(false);
        this.FinalizarPalePlanificado(pedidoSeleccionado, !pedidoSeleccionado.PaleReabierto, false);
      }
    },
    async EditarTipoEnvasado() {
      Log(this, this.EditarTipoEnvasado.name);
      this.articlesActionsOpened = false;
      PreloaderGH(true, true, this.$t('production.palletizing.changePackagingType.preloaderText'));
      const tempTipoEnvasadoPedido = {
        Id: 0,
        Pale: this.pedidoSeleccionado.Pale,
        Articulo: this.articuloSelecctionadoEdit,
        Envase: this.pedidoSeleccionado.Envase,
        Marca: this.pedidoSeleccionado.Marca,
        EnvasesPorPale: this.pedidoSeleccionado.CantidadEnvasesPorPalet,
      };
      this.tipoEnvasadoElementoProduccionSeleccionado = tempTipoEnvasadoPedido;
      const result = await this.ActualizarTipoEnvasadoXPuntoPaletizado();
      PreloaderGH(false);
      if (result) {
        this.TipoEnvasadoPaleActivoModificado();
        this.FinalizarPalePlanificado(this.pedidoEnCurso, !this.pedidoEnCurso.PaleReabierto, false);
      } else {
        HiNotification.Alert(this.$t('production.palletizing.changePackagingType.error'), this.$t('common.error'));
      }
    },

    /**
     * /**
     * Método común para finalizar un palé planificado.
     * @param {object} pedidoSeleccionado - Palé en curso de un pedido planificado (PPPSPP).
     * @param {boolean} mostrarPopupTag - Indica si se debe mostrar el popup de asignación de tag al finalizar el palé.
     * @param {boolean} mostrarPopupAsignacionManualDatosOrigenCajas - Indica si se debe mostrar el popup de asignación manual de datos de origen de cajas.
     */
    async FinalizarPalePlanificado(pedidoSeleccionado, mostrarPopupTag, mostrarPopupAsignacionManualDatosOrigenCajas) {
      Log(this, this.FinalizarPalePlanificado.name);
      // Sol.276217 -
      if (mostrarPopupAsignacionManualDatosOrigenCajas && this.puntoDePaletizadoSeleccionado.AsignacionManualDatosOrigenCajas && this.puntoDePaletizadoSeleccionado.UtilizarUIC) {
        this.popupAsignacionDatosOrigen = true;
        return;
      }
      if (this.puntoDePaletizadoSeleccionado.AsignarTagNFC && mostrarPopupTag) {
        if (mostrarPopupTag) {
          this.ultimoProcesoFin = 'FPP';
          this.popupTagNFCRequired = true;
        }
        if (!this.tagAsignadoCorrectamente) {
          return;
        }
        this.tagAsignadoCorrectamente = false;
      } else {
        this.tagAsignadoCorrectamente = false;
      }

      if (this.bloquearFinPaletSinDatosOrigen && !this.puntoDePaletizadoSeleccionado?.UtilizarUIC) {
        const existenDatosOrigenPuntoPaletizado = await this.DatosOrigenPuntoPaletizadoRegistroActivoTiempos();
        if (existenDatosOrigenPuntoPaletizado) {
          if (this.lineaSeleccionada.AsignarDatosOrigenPorPedido) {
            PreloaderGH(true, true, this.$t('production.palletizing.getOriginData.preloaderText'));
            const exitenDatosOrigenAsignacion = await this.CalcularDatosOrigenPorPedidoFinPale();
            PreloaderGH(false);
            if (!exitenDatosOrigenAsignacion) {
              this.$refs.UCConfirmation.create(
                this.$t('production.palletizing.getOriginData.noOriginDataAlert.title'),
                this.$t('production.palletizing.getOriginData.noOriginDataAlert.text'),
                () => {
                  this.EjecutarFinPaleEnCursoPlanificado(pedidoSeleccionado);
                },
              );
              this.$refs.UCConfirmation.show();
            } else {
              this.EjecutarFinPaleEnCursoPlanificado(pedidoSeleccionado);
            }
          } else {
            this.EjecutarFinPaleEnCursoPlanificado(pedidoSeleccionado);
          }
          return;
        }
        f7.dialog.create({
          title: this.$t('common.alert'),
          text: this.$t('production.palletizing.info.noOriginData'),
          buttons: [
            {
              text: this.$t('common.accept'),
            },
          ],
          verticalButtons: true,
        }).open();
        return;
      }
      if (this.lineaSeleccionada.AsignarDatosOrigenPorPedido) {
        PreloaderGH(true, true, this.$t('production.palletizing.getOriginData.preloaderText'));
        const exitenDatosOrigenAsignacion = await this.CalcularDatosOrigenPorPedidoFinPale();
        PreloaderGH(false);
        if (!exitenDatosOrigenAsignacion) {
          this.$refs.UCConfirmation.create(
            this.$t('production.palletizing.getOriginData.noOriginDataAlert.title'),
            this.$t('production.palletizing.getOriginData.noOriginDataAlert.text'),
            () => {
              this.EjecutarFinPaleEnCursoPlanificado(pedidoSeleccionado);
            },
          );
          this.$refs.UCConfirmation.show();
        } else {
          this.EjecutarFinPaleEnCursoPlanificado(pedidoSeleccionado);
        }
      } else {
        this.EjecutarFinPaleEnCursoPlanificado(pedidoSeleccionado);
      }
    },

    EjecutarFinPaleEnCursoPlanificado(pedidoSeleccionado) {
      Log(this, this.EjecutarFinPaleEnCursoPlanificado.name);
      const self = this;

      // SOL. 301134 - Comentamos este codigo y enviamos el tipoDeFinAtendiendoAPlanificacion siempre a true
      // let tipoDeFinAtendiendoAPlanificacion = false;
      // if (pedidoSeleccionado.PaleReabierto) tipoDeFinAtendiendoAPlanificacion = true;

      const tipoDeFinAtendiendoAPlanificacion = true;
      this.FinPale(tipoDeFinAtendiendoAPlanificacion).then((resolve) => {
        // Si el pale ha sido finalizado correctamente lo eliminamos.
        const tempPos = self.listadoPedidosPlanificados.indexOf(pedidoSeleccionado);
        self.listadoPedidosPlanificados.splice(tempPos, 1);
        self.pedidoEnCurso = null;
        self.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
        self.ActualizarPlanificadoYPartidasYPalesGenerados();
        if (resolve != null) {
          HiNotification.Toast(resolve);
        }
        // if (this.actualizarPaletizadoTrasFinalizarPale) { this.ActualizarPlanificadoYPartidasYPalesGenerados(); }
      });
    },

    async ConfirmButtonClickOriginData() {
      Log(this, this.ConfirmButtonClickOriginData.name);
      const res = await this.$refs.PCAsignacionDatosOrigen.ActualizarTrazabilidadCajas();
      this.popupAsignacionDatosOrigen = false;
      // if (res) eventBus.emit('confirmButtonClick');
      if (res) {
        if (this.pedidoSeleccionado != null) {
          this.FinalizarPalePlanificado(this.pedidoSeleccionado, false, false);
        } else {
          this.FinalizarPaleEnCursoNoPlanificado(false, false);
        }
      }
    },
    CancelButtonClickOriginData() {
      Log(this, this.CancelButtonClickOriginData.name);
      this.popupAsignacionDatosOrigen = false;
    },

    /**
     * Método común para finalizar un palé en curso no planificado.
     * @param {boolean} mostrarPopupTag - Indica si se debe mostrar el popup de asignación de tag al finalizar el palé.
     * @param {boolean} mostrarPopupAsignacionManualDatosOrigenCajas - Indica si se debe mostrar el popup de asignación manual de datos de origen de cajas.
     */
    async FinalizarPaleEnCursoNoPlanificado(mostrarPopupTag, mostrarPopupAsignacionManualDatosOrigenCajas) {
      Log(this, this.FinalizarPaleEnCursoNoPlanificado.name);
      // Sol.276217 -
      if (mostrarPopupAsignacionManualDatosOrigenCajas && this.puntoDePaletizadoSeleccionado.AsignacionManualDatosOrigenCajas && this.puntoDePaletizadoSeleccionado.UtilizarUIC) {
        this.popupAsignacionDatosOrigen = true;
        return;
      }
      if (this.puntoDePaletizadoSeleccionado.AsignarTagNFC && mostrarPopupTag) {
        if (mostrarPopupTag) {
          this.ultimoProcesoFin = 'FPNP';
          this.popupTagNFCRequired = true;
        }
        if (!this.tagAsignadoCorrectamente) {
          return;
        }
        this.tagAsignadoCorrectamente = false;
      } else {
        this.tagAsignadoCorrectamente = false;
      }

      if (this.bloquearFinPaletSinDatosOrigen && !this.puntoDePaletizadoSeleccionado?.UtilizarUIC) {
        const existenDatosOrigenPuntoPaletizado = await this.DatosOrigenPuntoPaletizadoRegistroActivoTiempos();
        if (existenDatosOrigenPuntoPaletizado) {
          if (this.lineaSeleccionada.AsignarDatosOrigenPorPedido) {
            PreloaderGH(true, true, this.$t('production.palletizing.getOriginData.preloaderText'));
            const exitenDatosOrigenAsignacion = await this.CalcularDatosOrigenPorPedidoFinPale();
            PreloaderGH(false);
            if (!exitenDatosOrigenAsignacion) {
              this.$refs.UCConfirmation.create(
                this.$t('production.palletizing.getOriginData.noOriginDataAlert.title'),
                this.$t('production.palletizing.getOriginData.noOriginDataAlert.text'),
                () => {
                  this.EjecutarFinPaleEnCursoNoPlanificado();
                  this.habilitarEdicion = false;
                },
              );
              this.$refs.UCConfirmation.show();
            } else {
              this.EjecutarFinPaleEnCursoNoPlanificado();
            }
          } else {
            this.EjecutarFinPaleEnCursoNoPlanificado();
            this.habilitarEdicion = false;
          }
          return;
        }
        f7.dialog.create({
          title: this.$t('common.alert'),
          text: this.$t('production.palletizing.info.noOriginData'),
          buttons: [
            {
              text: this.$t('common.accept'),
            },
          ],
          verticalButtons: true,
        }).open();

        return;
      }
      if (this.lineaSeleccionada.AsignarDatosOrigenPorPedido) {
        PreloaderGH(true, true, this.$t('production.palletizing.getOriginData.preloaderText'));
        const exitenDatosOrigenAsignacion = await this.CalcularDatosOrigenPorPedidoFinPale();
        PreloaderGH(false);
        if (!exitenDatosOrigenAsignacion) {
          this.$refs.UCConfirmation.create(
            this.$t('production.palletizing.getOriginData.noOriginDataAlert.title'),
            this.$t('production.palletizing.getOriginData.noOriginDataAlert.text'),
            () => {
              this.EjecutarFinPaleEnCursoNoPlanificado();
              this.habilitarEdicion = false;
            },
          );
          this.$refs.UCConfirmation.show();
        } else {
          this.EjecutarFinPaleEnCursoNoPlanificado();
        }
      } else {
        this.EjecutarFinPaleEnCursoNoPlanificado();
        this.habilitarEdicion = false;
      }
    },

    EjecutarFinPaleEnCursoNoPlanificado() {
      Log(this, this.EjecutarFinPaleEnCursoNoPlanificado.name);
      const self = this;
      this.FinPale(false).then(() => {
        // Si el pale ha sido finalizado correctamente lo eliminamos.
        self.paleEnCursoSinPlanificar = null;
        self.paleEnCursoSinPlanificarSeleccionado = null;
        self.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
        self.ActualizarPlanificadoYPartidasYPalesGenerados();
        HiNotification.Toast(this.$t('production.palletizing.info.finishPalletSuccess'));
      })
        .catch((error) => {
          LogError(this, this.EjecutarFinPaleEnCursoNoPlanificado.name, error);
        });
    },

    async CalcularDatosOrigenPorPedidoFinPale() {
      Log(this, this.CalcularDatosOrigenPorPedidoFinPale.name);
      const result = await ConexionTA.callCalcularDatosOrigenPorPedidoFinPale(this.puntoDePaletizadoSeleccionado.Id, this.pedidoEnCurso != null ? this.pedidoEnCurso.IdLineaPedidoVenta : 0);
      return result.Valor;
    },

    async DatosOrigenPuntoPaletizadoRegistroActivoTiempos() {
      Log(this, this.CalcularDatosOrigenPorPedidoFinPale.name);
      const result = await ConexionTA.callDatosOrigenPuntoPaletizadoRegistroActivoTiempos(this.puntoDePaletizadoSeleccionado.Id);
      return result.Valor;
    },

    NuevoPaleSinPedidoPlanificado() {
      Log(this, this.NuevoPaleSinPedidoPlanificado.name);
      if (this.pedidoEnCurso != null || this.paleEnCursoSinPlanificar != null) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToFinishToGenerateAnother'));
        return;
      }
      if (this.lineaSeleccionada == null || this.puntoDePaletizadoSeleccionado == null) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectLineAndPalletizingPoint'));
        return;
      }
      this.lineaDeProduccionSeleccionada = this.lineaSeleccionada; // Variable comun
      const tempFamiliaActiva = this.ObtenerFamiliaArticuloDeLaPartidaActivaEnElPuntoDePaletizadoSeleccionado();
      this.familiaArticuloSeleccionada = tempFamiliaActiva;
      this.popupNuevoPaleSinPedidoPlanificado = true;
    },

    ObtenerFamiliaArticuloDeLaPartidaActivaEnElPuntoDePaletizadoSeleccionado() {
      Log(this, this.ObtenerFamiliaArticuloDeLaPartidaActivaEnElPuntoDePaletizadoSeleccionado.name);
      if (this.partidasActivas === null || this.partidasActivas.length === 0) {
        return null;
      }
      if (this.partidasActivas[0] != null && this.partidasActivas[0].Articulo != null && this.partidasActivas[0].Articulo.Familia != null) {
        return this.partidasActivas[0].Articulo.Familia;
      }
      return null;
    },

    ProcesarListaPedidosPlanificados() {
      Log(this, this.ProcesarListaPedidosPlanificados.name);
      this.pedidoEnCurso = null;
      // Los pedidos vienen ordenados,  el de orden menor siempre sera el primero.
      this.ordenMinimoPedidosPlanificados = this.listadoPedidosPlanificados[0].Orden;
      this.pedidoEnCurso = this.listadoPedidosPlanificados.find((pedido) => pedido.TipoEstado === 1);
    },
    AniadirEnvasesConfeccionadosXLinea(lstEnvasesConfeccionados) {
      Log(this, this.AniadirEnvasesConfeccionadosXLinea.name);
      lstEnvasesConfeccionados.forEach((envases) => {
        this.listadoPedidosPlanificados.forEach((pedido) => {
          if (pedido.IdLineaPedidoVenta === envases.Id) {
            pedido.EnvasesConfeccionados = envases.EnvasesConfeccionados;
          }
        });
      });
    },

    SolicitarCambiarPrioridadParaIniciarPedido() {
      Log(this, this.SolicitarCambiarPrioridadParaIniciarPedido.name);
      HiNotification.Toast(this.$t('production.palletizing.info.needToChangeOrderToStart'));
    },

    SolicitudCambioDeOrden(evt) {
      Log(this, this.SolicitudCambioDeOrden.name);
      this.pedidoSeleccionado = evt.draggedContext.element;
      return true;
    },

    CambioDeOrdenFinalizado() {
      Log(this, this.CambioDeOrdenFinalizado.name);
      this.drag = false;
      if (this.pedidoSeleccionado != null) {
        this.GuardarOrdenPedidosActuales();
      }
    },

    SeleccionarPedido(pedido) {
      Log(this, this.SeleccionarPedido.name);
      if (this.puntoDePaletizadoSeleccionado.UsoEnIntegracion) {
        HiNotification.Toast(this.$t('production.palletizing.info.palletizingPointInIntegrationProcess'));
        return;
      }
      this.pedidoSeleccionado = pedido;
      this.paleEnCursoSinPlanificarSeleccionado = null;
      if (this.puntoDePaletizadoSeleccionado.PermiteRegistroProductividadTrabajadores) {
        this.ObtenerDatoComplementarioNACxEnvase(this.pedidoSeleccionado.Envase.Id);
      }
      if (this.pedidoSeleccionado.TipoEstado === 1) {
        this.habilitarEdicion = true;
      } else {
        this.habilitarEdicion = false;
      }
    },

    SubirPrioridadDePedidosSeleccionados() {
      Log(this, this.SubirPrioridadDePedidosSeleccionados.name);
      if (this.pedidoSeleccionado == null) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectAnOrder'));
        return;
      }
      const tempPosActual = this.listadoPedidosPlanificados.indexOf(this.pedidoSeleccionado);
      if (tempPosActual === 0) {
        HiNotification.Toast(this.$t('production.palletizing.info.orderAlreadyHasHighestPriority'));
        return;
      }
      const tempElementoMover = this.listadoPedidosPlanificados[tempPosActual];
      const tempElementoDesplazado = this.listadoPedidosPlanificados[tempPosActual - 1];
      this.listadoPedidosPlanificados[tempPosActual] = tempElementoDesplazado;
      this.listadoPedidosPlanificados[tempPosActual - 1] = tempElementoMover;
      const tempListaPEdidosPlanificados = this.listadoPedidosPlanificados;
      this.listadoPedidosPlanificados = null;
      sleep(10).then(() => {
        this.listadoPedidosPlanificados = tempListaPEdidosPlanificados;
        this.GuardarOrdenPedidosActuales();
      });
    },

    BajarPrioridadDePedidosSeleccionados() {
      Log(this, this.BajarPrioridadDePedidosSeleccionados.name);
      if (this.pedidoSeleccionado == null) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectAnOrder'));
        return;
      }
      const tempPosActual = this.listadoPedidosPlanificados.indexOf(this.pedidoSeleccionado);
      if (tempPosActual === this.listadoPedidosPlanificados.length - 1) {
        HiNotification.Toast(this.$t('production.palletizing.info.orderAlreadyHasLowestPriority'));
        return;
      }
      const tempElementoMover = this.listadoPedidosPlanificados[tempPosActual];
      const tempElementoDesplazado = this.listadoPedidosPlanificados[tempPosActual + 1];
      this.listadoPedidosPlanificados[tempPosActual] = tempElementoDesplazado;
      this.listadoPedidosPlanificados[tempPosActual + 1] = tempElementoMover;
      const tempListaPedidosPlanificados = this.listadoPedidosPlanificados;
      this.listadoPedidosPlanificados = null;

      sleep(10).then(() => {
        this.listadoPedidosPlanificados = tempListaPedidosPlanificados;
        this.GuardarOrdenPedidosActuales();
      });
    },

    /** Refreca sin Obtener nuevos Datos */
    ForzarRefrescoDePedidosMostradosEnPantalla() {
      Log(this, this.ForzarRefrescoDePedidosMostradosEnPantalla.name);
      const self = this;
      this.mostrarPrecarga = true;
      const tempListaPedidosPlanificados = Object.assign([], this.listadoPedidosPlanificados); // Clonamos
      this.listadoPedidosPlanificados = [];

      sleep(100).then(() => {
        this.listadoPedidosPlanificados = tempListaPedidosPlanificados;
        self.mostrarPrecarga = false;
      });
    },

    ActualizarPedidosMostradosEnPantalla() {
      Log(this, this.ActualizarPedidosMostradosEnPantalla.name);
      this.listadoPedidosPlanificados = null;
      this.pedidoSeleccionado = null;
      if (this.puntoDePaletizadoSeleccionado) {
        this.ObtenerTodosLosPedidosPlanificadosDeLaLinea();
      }
    },

    MostrarEdicionDePaleEnCurso() {
      Log(this, this.MostrarEdicionDePaleEnCurso.name);
      if (this.pedidoSeleccionado != null && this.pedidoSeleccionado.TipoEstado !== 1) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectAnOrderOrActivePallet'));
        return;
      }

      if (this.pedidoSeleccionado == null && this.paleEnCursoSinPlanificarSeleccionado == null) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectAnOrderOrActivePallet'));
        return;
      }
      if (this.pedidoSeleccionado != null && this.paleEnCursoSinPlanificarSeleccionado != null) {
        HiNotification.Toast(this.$t('production.palletizing.info.twoElementsSelected'));
        return;
      }
      // Modificación de TipoDeEnvasado de un palé generado desde pedido.
      if (this.pedidoSeleccionado != null) {
        this.pedidoPlanificadoSeleccionado = this.pedidoSeleccionado;
        if (this.pedidoSeleccionado.TipoEnvasadoElementoProduccion != null && !this.pedidoSeleccionado.PaleReabierto) {
          this.tipoEnvasadoElementoProduccionSeleccionado = this.pedidoSeleccionado.TipoEnvasadoElementoProduccion;
        } else {
          const tempTipoEnvasadoPedido = {
            Id: 0,
            Pale: this.pedidoSeleccionado.Pale,
            Articulo: this.pedidoSeleccionado.Producto.Composicion?.Componentes.find((c) => c.Componente.TipoArticulo === 'Producto')?.Componente || this.pedidoSeleccionado.Producto,
            Envase: this.pedidoSeleccionado.Envase,
            Marca: this.pedidoSeleccionado.Marca,
            EnvasesPorPale: this.pedidoSeleccionado.CantidadEnvasesPorPalet,
          };
          this.tipoEnvasadoElementoProduccionSeleccionado = tempTipoEnvasadoPedido;
        }
      }
      // Modificacion del TipoEnvasado de un palé generado SIN Pedido.
      if (this.paleEnCursoSinPlanificarSeleccionado != null) {
        this.tipoEnvasadoElementoProduccionSeleccionado = this.paleEnCursoSinPlanificarSeleccionado;
        this.edicionPaleSinPedido = true;
      } else {
        this.edicionPaleSinPedido = false;
      }
      this.popupEdicionPedidoPlanificadoAbierto = true;
    },

    TipoEnvasadoPaleActivoModificado() {
      Log(this, this.TipoEnvasadoPaleActivoModificado.name);
      const tempTipoEnvasadoModificado = this.tipoEnvasadoElementoProduccionSeleccionado;
      // Se ha modificado el TipoDeEnvasado de un palé generado desde pedido.
      if (this.pedidoSeleccionado != null) {
        this.listadoPedidosPlanificados.find((p) => p.IdLineaPedidoVenta === this.pedidoSeleccionado.IdLineaPedidoVenta && p.IdPedidoVenta === this.pedidoSeleccionado.IdPedidoVenta).TipoEnvasadoElementoProduccion = tempTipoEnvasadoModificado;
      }
      // Se ha modificacion del TipoEnvasado de un palé generado SIN Pedido.
      if (this.paleEnCursoSinPlanificarSeleccionado != null) {
        this.paleEnCursoSinPlanificarSeleccionado = tempTipoEnvasadoModificado;
        this.paleEnCursoSinPlanificar = tempTipoEnvasadoModificado;
      }
      this.totalEnvases = Number.parseInt(tempTipoEnvasadoModificado.EnvasesPorPale, 10);
      this.ForzarRefrescoDePedidosMostradosEnPantalla();
    },

    ComprobarSiElTipoEnvasadoDelPedidoEsIgualAlTipoEnvasadoDelPaleEnCurso(tempPedido) {
      Log(this, this.ComprobarSiElTipoEnvasadoDelPedidoEsIgualAlTipoEnvasadoDelPaleEnCurso.name);
      if (tempPedido.TipoEnvasadoElementoProduccion != null) {
        try {
          if (tempPedido.Producto.Id !== tempPedido.TipoEnvasadoElementoProduccion.Articulo.Id) {
            return true;
          }
          if (tempPedido.Envase.Id !== tempPedido.TipoEnvasadoElementoProduccion.Envase.Id) {
            return true;
          }
          if (tempPedido.Pale.Id !== tempPedido.TipoEnvasadoElementoProduccion.Pale.Id) {
            return true;
          }
          if (tempPedido.Marca.Id !== tempPedido.TipoEnvasadoElementoProduccion.Marca.Id) {
            return true;
          }
          if (tempPedido.CantidadEnvasesPorPalet !== tempPedido.TipoEnvasadoElementoProduccion.EnvasesPorPale) {
            return true;
          }
          return false;
        } catch (e) {
          LogError(this, this.ComprobarSiElTipoEnvasadoDelPedidoEsIgualAlTipoEnvasadoDelPaleEnCurso.name, e);
        }
      }
      return false;
    },

    ObtenerPosiblePaleEnCursoSinPedidoPlanificado() {
      Log(this, this.ObtenerPosiblePaleEnCursoSinPedidoPlanificado.name);
      this.ObtenerPaleActivoSinPedidoPlanificado();
    },

    CerrarFrmEdicion() {
      Log(this, this.CerrarFrmEdicion.name);
      this.popupEdicionPedidoPlanificadoAbierto = false;
      this.pedidoPlanificadoSeleccionado = null;
      this.tipoEnvasadoElementoProduccionSeleccionado = null;
    },

    CerrarFrmNuevoPale() {
      Log(this, this.CerrarFrmNuevoPale.name);
      this.popupNuevoPaleSinPedidoPlanificado = false;
    },

    NuevoPaleSinPedidoPlanificadoGenerado() {
      Log(this, this.NuevoPaleSinPedidoPlanificadoGenerado.name);
      this.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
      this.ObtenerPosiblePaleEnCursoSinPedidoPlanificado();
      // this.RestablecerUbicacionDefectoPuntoPaletizadoSeleccionado();
    },

    RestablecerUbicacionDefectoPuntoPaletizadoSeleccionado() {
      Log(this, this.RestablecerUbicacionDefectoPuntoPaletizadoSeleccionado.name);
      this.puntosDePaletizado.filter((p) => p.Id === this.puntoDePaletizadoSeleccionado.Id).UbicacionPalesProducidos = this.puntoDePaletizadoSeleccionado.UbicacionDefectoPalesProducidos;
      this.puntoDePaletizadoSeleccionado.UbicacionPalesProducidos = this.puntoDePaletizadoSeleccionado.UbicacionDefectoPalesProducidos;
    },

    ActualizarPlanificadoYPartidasYPalesGenerados() {
      Log(this, this.ActualizarPlanificadoYPartidasYPalesGenerados.name);
      this.ActualizarPartidasYPalesGenerados();
      this.ActualizarPedidosMostradosEnPantalla();
      this.UpdateQuantity();
      this.paleEnCursoSinPlanificar = null;
      this.paleEnCursoSinPlanificarSeleccionado = null;
      this.habilitarEdicion = false;
    },

    ActualizarPartidasYPalesGenerados() {
      Log(this, this.ActualizarPartidasYPalesGenerados.name);
      this.$refs.componentePCPartidasActivasYRecientesLinea.ActualizarDatos(true);
      this.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
    },

    MostrarDetalleLineaPedidoPlanificado(pedidoSeleccionado) {
      Log(this, this.MostrarDetalleLineaPedidoPlanificado.name);
      this.pedidoSeleccionado = pedidoSeleccionado;
      // Es necesario que se realice la seleccón del pedidoSeleccionado antes de abrir el popup
      sleep(50).then(() => {
        this.popupDetallePedidoSeleccionadoAbierto = true;
      });
    },

    AbrirPopupParaBusquedaDePales() {
      Log(this, this.AbrirPopupParaBusquedaDePales.name);
      if (this.lineaSeleccionada == null || this.lineaSeleccionada === undefined || this.puntoDePaletizadoSeleccionado == null || this.puntoDePaletizadoSeleccionado === undefined) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectLineAndPalletizingPoint'));
        return;
      }
      this.nombreFrmPCUltimosPalesGenerados = this.$t('BusquedaDePale');
      this.$refs.componentePCUltimosPalesGenerados.VerMasPales();
    },

    CerrarPopupAsignacionCajasPale() {
      Log(this, this.CerrarPopupAsignacionCajasPale.name);
      this.objANSEnCursoPuntoPaletizado = null;
      this.UpdateQuantity();
    },
    CerraPopupConValidacion() {
      Log(this, this.CerraPopupConValidacion.name);
      if (this.cajasPendintesDeSinc.length > 0) {
        this.$refs.componenteConfirmacionArticulosPendientes.create(
          'Existen articulos pendintes de sincronizar',
          'Esta acción eliminara los articulos. ¿Deseas continuar con la acción?',
          () => {
            this.$refs.PCLecturaEnvasesPale.RestablecerArticulosLocales();
            this.$refs.PCLecturaEnvasesPale.RestablecerFrm();
            this.popupAsignacionCajasPale = false;
          // this.EliminarArticuloElaborado(objArticuloElaborado);
          },
        );
        this.$refs.componenteConfirmacionArticulosPendientes.show();
      } else {
        this.popupAsignacionCajasPale = false;
        this.$refs.PCLecturaEnvasesPale.RestablecerFrm();
      }
    },
    SincronizarCajas() {
      Log(this, this.SincronizarCajas.name);
      this.$refs.PCLecturaEnvasesPale.GuardarCajasPendientes();
    },

    async CerrarPopupAsignacionActividadPorEnvase() {
      Log(this, this.CerrarPopupAsignacionActividadPorEnvase.name);
      if (!this.configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarras && !this.configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarrasManual) {
        this.articuloElaboradoSelccionado = null;
        await this.$refs.PCLecturaEnvasesPale.RestablecerFrm();
        await this.$refs.PCLecturaEnvasesPale.PaleEstablecido(this.objANSEnCursoPuntoPaletizado);
      }
    },
    EditarActividadPorEnvase(artElaborado) {
      Log(this, this.EditarActividadPorEnvase.name);
      this.articuloElaboradoSelccionado = artElaborado;
      this.popupAsignacionActividadPorEnvase = true;
    },
    MostrarSincronizacion(valor) {
      Log(this, this.MostrarSincronizacion.name);
      this.cajasPendintesDeSinc = valor;
    },
    AddRegistroActividadAE(registro) {
      Log(this, this.AddRegistroActividadAE.name);
      this.$refs.PCLecturaEnvasesPale.AddRegistroActividadGuardadosAE(registro);
    },
    RegistroLocalEliminado(registroLocal) {
      Log(this, this.RegistroLocalEliminado.name);
      this.$refs.PCLecturaEnvasesPale.EliminarRegistroLocal(registroLocal);
    },

    async AbrirPopupParaRegistrarCajasPale() {
      Log(this, this.AbrirPopupParaRegistrarCajasPale.name);
      if (this.lineaSeleccionada == null || this.lineaSeleccionada === undefined || this.puntoDePaletizadoSeleccionado == null || this.puntoDePaletizadoSeleccionado === undefined) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectLineAndPalletizingPoint'));
        return;
      }
      // if (!this.puntoDePaletizadoSeleccionado.PermiteRegistroProductividadTrabajadores) {
      //   HiNotification.Toast(this.$t('ElPPNoPermiteRegProdTrab'));
      //   return;
      // }

      if (!this.puntoDePaletizadoSeleccionado.PermiteRegistroProductividadTrabajadores
        && !this.puntoDePaletizadoSeleccionado.UtilizarUIC
        && this.puntoDePaletizadoSeleccionado.TipoFinPalet !== TipoFinPaletPuntoPaletizado.ManualLecturaBultoABulto) {
        HiNotification.Toast(this.$t('ElPPNoPermiteRegProdTrab'));
        return;
      }

      this.objANSEnCursoPuntoPaletizado = await this.Conexion_ObtenerPaleEnCursoPuntoPaletizado(this.puntoDePaletizadoSeleccionado);

      if (this.objANSEnCursoPuntoPaletizado != null || this.paleEnCursoSinPlanificarSeleccionado !== null || this.pedidoSeleccionado !== null) {
        this.popupAsignacionCajasPale = true;
      } else {
        HiNotification.Toast(this.$t('FuncionalidadNoDisponible'));
      }
    },
    EliminadoPedidoPlanificadoEnPuntoPaletizado(objPedido) {
      Log(this, this.EliminadoPedidoPlanificadoEnPuntoPaletizado.name);
      const self = this;
      HiDialog.Preloader(true, 'Finalizando línea de pedido');
      this.EliminarPedidoPlanificadoEnPuntoPaletizado(
        objPedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado,
        this.puntoDePaletizadoSeleccionado.Id,
        objPedido.IdLineaPedidoVenta,
      )
        .then(() => {
          HiDialog.Preloader(false);
          HiNotification.Toast('Línea de pedido finalizada');
          self.ActualizarPlanificadoYPartidasYPalesGenerados();
        })
        .catch((error) => {
          HiDialog.Preloader(false);
          if (error.Codigo === '214') {
            HiNotification.Toast('El pedido no pudo ser finalizado. El pedido esta en curso y tiene un palé en producción es necesario finalizar el palé en curso antes de finalizar la producción');
          } else {
            HiNotification.Toast('El pedido no pudo ser finalizado');
          }
        });
    },

    AbrirVerMasPalesDeComponentePCUltimosPalesGenerados() {
      Log(this, this.AbrirVerMasPalesDeComponentePCUltimosPalesGenerados.name);
      this.nombreFrmPCUltimosPalesGenerados = 'Palés Generados';
      this.$refs.componentePCUltimosPalesGenerados.VerMasPales();
    },

    ReabrirPaleConfeccionadoEnPuntoDePaletizado(paleParaReabrir) {
      Log(this, this.ReabrirPaleConfeccionadoEnPuntoDePaletizado.name);
      const self = this;
      if (this.ConsultarSiExisteUnPaleEnCurso()) {
        HiNotification.Toast(this.$t('DetenerPaleEnCursoAntesDeReabrir'));
        return;
      }
      // Si el punto de paletizado tiene marcado el check "Asignación manual de datos origen cajas" no se permitirá hacer retrabajo
      if (this.puntoDePaletizadoSeleccionado.AsignacionManualDatosOrigenCajas) {
        HiNotification.Toast(this.$t('PaleNoReabiertoPuntoPalUtilizaAsignacionManualDatosOrigenCajas'));
        return;
      }
      PreloaderGH(true, true, this.$t('GenerandoRetrabajoPale'));
      this.MoverPalePuntoPaletizadoParaRetrabajarlo(paleParaReabrir.Id, this.puntoDePaletizadoSeleccionado.Id).then(() => {
        PreloaderGH(false);
        HiNotification.Toast(this.$t('RetrabajoPaleRealizado'));
        self.ActualizarPlanificadoYPartidasYPalesGenerados();
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Toast(error);
        });
    },

    ProcesarRespuestaPaleActivoSinPedidoPlanificado(elementoPaleEnProduccion) {
      Log(this, this.ProcesarRespuestaPaleActivoSinPedidoPlanificado.name);

      this.elementoPaleEnProduccion = elementoPaleEnProduccion;

      /** Comprobaremos si se trata de un palé sin pedido o un palé reabierto con o sin pedido origen */
      if (elementoPaleEnProduccion.PuntoPaletizadoRegistro.ArticuloNumeroSerieOrigen == null || elementoPaleEnProduccion.InformacionPedidoOrigen == null) {
        this.paleEnCursoSinPlanificar = elementoPaleEnProduccion.TipoEnvasadoElementoProduccion;
        if (elementoPaleEnProduccion.PuntoPaletizadoRegistro.ArticuloNumeroSerieOrigen != null) {
          this.paleReabiertoEnPuntoDePaletizado = elementoPaleEnProduccion;
        }

        this.PermitirFinPaleLecturaUltimaCaja();
      } else {
        // Palé en curso reabierto con pedido planificado
        this.paleReabiertoEnPuntoDePaletizado = elementoPaleEnProduccion;
        this.listadoPedidosPlanificados ??= [];

        // NOTA: Viene de un pedido retrabajado por lo tanto el número de envase se modifico y no es el total
        // Por lo tanto ahora en el retrabajo establecemos la cantidad de envases a la total de la solicitada en el pedido.
        elementoPaleEnProduccion.InformacionPedidoOrigen.TipoEnvasadoElementoProduccion.EnvasesPorPale = elementoPaleEnProduccion.InformacionPedidoOrigen.CantidadEnvasesPorPalet;
        this.listadoPedidosPlanificados.splice(0, 0, elementoPaleEnProduccion.InformacionPedidoOrigen); // Insertamos en la posicion 0 sin eliminar.
        this.ProcesarListaPedidosPlanificados();
      }

      this.EstablecerPalesActivosPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id);
      this.UpdateQuantity();
    },

    ActualizarNumeroAlertasYNotificaciones() {
      Log(this, this.ActualizarNumeroAlertasYNotificaciones.name);
      eventBus.emit('PCVisorDeAlertasYNotificaciones_actualizarNumeroAlertas'); // Actualizamos el número de las alertas.
    },

    /** Si en la configuracion esta establecido que se filtren las notificaciones unicamnete mostrara las de los pedidos de la linea y PP actual */
    FiltraNotificacionesDePedidosVisualizados() {
      Log(this, this.FiltraNotificacionesDePedidosVisualizados.name);
      const self = this;
      // var arrayTexto = ['pedido de venta /646']
      let arrayTexto = [];
      // Consultamos si mostrar todas las alertas o solo las de pedidos visualizados.
      if (!this.filtrarAlertasYNotificacionesPorLineaYPuntoDePaletizadoSeleccionado) {
        if (this.mostrarAlertasYNotificacionesDePedidosModificados) {
          // Filtamos las alertas de pedidos modificados (se añaden o quitan palés)
          arrayTexto.push('pedido de venta ');
        }
        if (this.mostrarAlertasYNotificacionesDePlanificacionesYDesplanificaciones) {
          // Filtamos las alertas de planificaciones o desplanificaciones de pedidos sobre el punto de paletizado actual
          arrayTexto.push('en el punto de paletizado ');
        }
        // Mostramos solo las alertas de pedidos visualizados.
      } else if (this.listadoPedidosPlanificados != null && this.listadoPedidosPlanificados !== undefined) {
        if (this.mostrarAlertasYNotificacionesDePedidosModificados) {
          // Filtamos las alertas de pedidos modificados (se añaden o quitan palés)
          this.listadoPedidosPlanificados.forEach((pedidoPlanificado) => {
            let cadenaFiltro = 'pedido de venta ';
            cadenaFiltro = cadenaFiltro.concat(SoporteCadena.EliminarCaracteresContenidosEnUnaCadena(pedidoPlanificado.Pedido, '.'));
            arrayTexto.push(cadenaFiltro);
          });
        }
        if (this.mostrarAlertasYNotificacionesDePlanificacionesYDesplanificaciones) {
          // Filtamos las alertas de planificaciones o desplanificaciones de pedidos sobre el punto de paletizado actual
          this.listadoPedidosPlanificados.forEach(() => {
            let cadenaFiltro = 'en el punto de paletizado ';
            cadenaFiltro = cadenaFiltro.concat(self.puntoDePaletizadoSeleccionado.Codigo);
            arrayTexto.push(cadenaFiltro);
          });
        }
      }
      // Procesamos todos los filtros de las alertas con el formato necesario
      const tempFiltrosAletasFormato = [];
      arrayTexto = Array.from(new Set(arrayTexto)); // Quitamos los duplicados
      arrayTexto.forEach((textoAlerta) => {
        tempFiltrosAletasFormato.push({
          TipoAlertaOrigenBusqueda: 'ControlProduccion',
          TextoBusqueda: textoAlerta,
          FechaInicioBusqueda: '2022-11-15T09:41:52.330Z',
          FechaFinBusqueda: '2022-11-18T12:41:52.330Z',
        });
      });

      this.criteriosDeBusquedaParaAlertasNotificacionDelUsuario = tempFiltrosAletasFormato;
    },

    EliminarFiltrosDeAlertasParaLosPedidosMostrados() {
      Log(this, this.EliminarFiltrosDeAlertasParaLosPedidosMostrados.name);
      this.criteriosDeBusquedaParaAlertasNotificacionDelUsuario = null;
      this.ActualizarNumeroAlertasYNotificaciones();
    },

    /**
     * Handles the selection of an option in the side navbar.
     * @param {SideNavbarItem} item - The selected option.
     */
    OpcionSideNavbarSeleccionada(item) {
      Log(this, this.OpcionSideNavbarSeleccionada.name);

      if (item.key === 'more') {
        this.popupConfiguracionPaletizado = true;
      }
    },

    SolicitudEliminarPaleEnCursoEnPuntoPaletizado(confirmacion) {
      Log(this, this.SolicitudEliminarPaleEnCursoEnPuntoPaletizado.name);
      const self = this;
      if (this.pedidoSeleccionado != null && this.pedidoSeleccionado.TipoEstado !== 1) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectAnOrderOrActivePallet'));
        return;
      }
      if (this.pedidoSeleccionado == null && this.paleEnCursoSinPlanificarSeleccionado == null) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectAnOrderOrActivePallet'));
        return;
      }
      if (this.pedidoSeleccionado != null && this.paleEnCursoSinPlanificarSeleccionado != null) {
        HiNotification.Toast(this.$t('production.palletizing.info.twoElementsSelected'));
        return;
      }

      if (!confirmacion) {
        this.$refs.UCConfirmation.create(
          this.$t('production.palletizing.resetPalletizingPoint.title').toUpperCase(),
          this.$t('production.palletizing.resetPalletizingPoint.text'),
          () => {
            this.SolicitudEliminarPaleEnCursoEnPuntoPaletizado(true);
          },
        );
        this.$refs.UCConfirmation.show();
        return;
      }
      // Eliminar palé de un pedido.
      if (this.pedidoSeleccionado != null) {
        this.EliminarPaleEnCursoEnPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id, this.pedidoSeleccionado.IdLineaPedidoVenta, this.pedidoSeleccionado.IdPartesProduccionPrevistoSalidaPuntoPaletizado, this.pedidoSeleccionado.OrdenProduccion != null ? this.pedidoSeleccionado.OrdenProduccion.Id : 0).then((result) => {
          if (result.Valor) {
            self.ActualizarPlanificadoYPartidasYPalesGenerados();
            HiNotification.Toast(this.$t('production.palletizing.info.palletRemoveAndReplanified'));
          } else {
            HiNotification.Toast(result.Mensaje);
          }
        });
      } else {
        // Eliminar palé en curso no planificado
        this.EliminarPaleEnCursoEnPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id, 0, 0, 0).then((result) => {
          if (result.Valor) {
            self.RestablecerListasDePedidosYPales();
            self.ActualizarPlanificadoYPartidasYPalesGenerados();
            HiNotification.Toast(this.$t('production.palletizing.info.palletHasBeenRemoved'));
          } else {
            HiNotification.Toast(result.Mensaje);
            self.RestablecerListasDePedidosYPales();
            self.ActualizarPlanificadoYPartidasYPalesGenerados();
          }
        });
      }
    },

    /**
     * @public
     * @returns {void}
     */
    ResetearVolcadosActivos() {
      Log(this, this.ResetearVolcadosActivos.name);
      this.$refs.componentePCPartidasActivasYRecientesLinea.ResetearVolcadosActivos(false);
    },

    /* Sol.230274  (Palés reservados con posterioridad a la planificación) */
    ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido() {
      Log(this, this.ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido.name);
      const self = this;
      PreloaderGH(true, false, this.$t('common.updatingQuantities'));
      this.Conexion_ActualizarCantidadDePalesPlanificadosDeUnaLineaPedidoVenta(
        this.puntoDePaletizadoSeleccionado.Id,
        this.pedidoSeleccionado.IdLineaPedidoVenta,
        this.pedidoSeleccionado.IdPartesProduccionPrevistoSalidaPuntoPaletizado,
        this.pedidoSeleccionado.OrdenProduccion.Id,
      ).then((result) => {
        if (result.Valor) {
          PreloaderGH(false);
          self.ActualizarPlanificadoYPartidasYPalesGenerados();
          HiNotification.Toast(result.Mensaje);
          self.popupDetallePedidoSeleccionadoAbierto = false;
        } else {
          PreloaderGH(false);
          HiNotification.Toast(result.Mensaje);
          self.popupDetallePedidoSeleccionadoAbierto = false;
        }
      })
        .catch((error) => {
          PreloaderGH(false);
          // self.mostrarPrecargaPedidosPlanificados = false;
          HiNotification.Alert(`${this.$t('common.checkYourConnection')} ${error}`, this.$t('common.error'));
          LogError(this, this.ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido.name, error);
        });
    },

    FormatearXDecimales(numero, decimales) {
      return SoporteNumeracion.FormatearXDecimales(numero, decimales);
    },

    FormatearCadena(cadena, longitudMaxima) {
      if (cadena == null) {
        return '';
      }
      return SoporteCadena.TextoLogitudMaxima(cadena, longitudMaxima);
    },

    PaleFinalizadoMedianteLecturaUltimaCaja() {
      Log(this, this.PaleFinalizadoMedianteLecturaUltimaCaja.name);
      // Si el pale ha sido finalizado correctamente lo eliminamos.
      this.RestablecerListasDePedidosYPales();
      this.ObtenerTodosLosPedidosPlanificadosDeLaLinea();
      this.pedidoEnCurso = null;
      this.$refs.componentePCUltimosPalesGenerados.ActualizarDatos();
    },

    AbrirOpcionesPuntoPaletizadoSeleccionado() {
      Log(this, this.AbrirOpcionesPuntoPaletizadoSeleccionado.name);
      if (this.puntoDePaletizadoSeleccionado == null) {
        HiNotification.Toast(this.$t('production.palletizing.info.needToSelectPalletizingPoint'));
        return;
      }
      this.popupConfiguracionPuntoPaletizadoSelecionado = true;
    },

    ConfiguracionPuntoPaletizadoSelecionadoModificada(nuevaConfiguracion) {
      Log(this, this.ConfiguracionPuntoPaletizadoSelecionadoModificada.name);
      this.popupConfiguracionPuntoPaletizadoSelecionado = false;
      if (nuevaConfiguracion === null) {
        HiNotification.Toast(this.$t('production.palletizing.info.invalidPalletizingPointConfiguration'));
        return;
      }
      this.puntosDePaletizado.filter((p) => p.Id === this.puntoDePaletizadoSeleccionado.Id).UbicacionPalesProducidos = nuevaConfiguracion.UbicacionDestinoPalesProduccidos;
      this.puntoDePaletizadoSeleccionado.UbicacionPalesProducidos = nuevaConfiguracion.UbicacionDestinoPalesProduccidos;
    },

    IniciarPale() {
      Log(this, this.IniciarPale.name);
      const self = this;
      HiDialog.Preloader(true, 'Iniciando Palé');
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callIniciarPale(
          this.puntoDePaletizadoSeleccionado.Id,
          this.lineaSeleccionada.Id,
          this.pedidoSeleccionado.IdLineaPedidoVenta,
          this.verificarReservaDePalesAntesDeGeneraNuevoPaleDePedido, // VerificarPalesPlanificadosReservados
        ).then((result) => {
          if (result.Valor) {
            resolve(result);
            HiDialog.Preloader(false);
          } else {
            reject(result);
            HiDialog.Preloader(false);
          }
        })
          .catch((error) => {
            reject(error);
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    FinPale(tipoDeFinAtendiendoAPlanificacion) {
      Log(this, this.FinPale.name);
      const self = this;
      // if (this.pedidoEnCurso != null) { this.weight = this.FormatearXDecimales(((this.pedidoEnCurso.PesoBruto / this.pedidoEnCurso.CantidadPalesTotalesDeLaLineaPedido) * this.pedidoEnCurso.CantidadPalet), 2); }
      HiDialog.Preloader(true, this.$t('production.palletizing.finishPale.preloaderText'));
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarPaleEnUbicacion(
          this.puntoDePaletizadoSeleccionado.Id,
          this.lineaSeleccionada.Id,
          tipoDeFinAtendiendoAPlanificacion,
          this.puntoDePaletizadoSeleccionado.UbicacionPalesProducidos != null ? this.puntoDePaletizadoSeleccionado.UbicacionPalesProducidos.Id : 0,
          this.imprimirEtiquetaFinPale,
        ).then((result) => {
          if (result.Valor) {
            HiDialog.Preloader(false);
            if (this.pesajeFinPale) {
              this.ObtenerUltimosPalesGenerados();
            }
            resolve(result.Mensaje);
          } else {
            HiNotification.Toast(result.Mensaje);
            HiDialog.Preloader(false);
            reject();
          }
        })
          .catch((error) => {
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            reject();
            LogError(this, this.FinPale.name, error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    async ObtenerUltimosPalesGenerados() {
      Log(this, this.ObtenerUltimosPalesGenerados.name);

      try {
        const result = await callExecuteSPERP(
          'APPTRAZABILIDAD_UltimosArticuloNumeroSerieConfeccionados',
          [
            { NombreParametro: 'idPuntoPaletizado', Valor: this.puntoDePaletizadoSeleccionado.Id },
            { NombreParametro: 'numeroRegistrosMostrar', Valor: 1 },
          ],
          'Almacen.UnidadContenedoraJSON',
        );
        if (result.data.length > 0) {
          this.idUltimoPale = result.data[0].Id;
          this.weight = result.data[0].PesoBruto;
          this.actionsWeighingReading = true;
        }
      } catch (error) {
        LogError(this, this.ObtenerUltimosPalesGenerados.name, error);
      }
    },

    EventPartidasActivas(lst) {
      Log(this, this.EventPartidasActivas.name);
      this.partidasActivas = lst;
    },

    async EventLecturaDeTagNFC(valorCampo) {
      Log(this, this.EventLecturaDeTagNFC.name);
      const self = this;
      PreloaderGH(true, true, this.$t('production.palletizing.assigningTag.preloaderText'));
      let idNumeroSerie = null;
      const tag = valorCampo;
      this.valorCampoLectura = '';
      const result = await ConexionTA.callObtenerUltimosPalesConfeccionadosYEnConfeccion(this.puntoDePaletizadoSeleccionado.Id, 0);
      if (result.Valor) {
        const resJSON = JSON.parse(result.Mensaje);
        if (resJSON.PalesEnCurso.length > 0) {
          idNumeroSerie = resJSON.PalesEnCurso[0].Id_NumeroSerie;
        } else {
          PreloaderGH(false);
          this.popupTagNFCRequired = false;
          HiNotification.Toast(this.$t('production.palletizing.assigningTag.noPalletStarted'));
          return;
        }
      } else {
        self.HiNotification.Alert(this.$t('production.palletizing.assigningTag.cannotGetStartedPallet'), this.$t('common.error'));
      }
      this.Conexion_AsignarTagNFCPale(tag, idNumeroSerie).then((resultTag) => {
        PreloaderGH(false);
        if (resultTag.Valor) {
          this.tagAsignadoCorrectamente = true;
          this.popupTagNFCRequired = false;
          HiNotification.Toast(this.$t('production.palletizing.assigningTag.tagAssigned'));
          if (this.ultimoProcesoFin === 'FPP') {
            this.FinalizarPalePlanificado(this.pedidoSeleccionado, false, false);
          } else {
            this.FinalizarPaleEnCursoNoPlanificado(false, false);
          }
        } else {
          this.popupTagNFCRequired = false;
          this.tagAsignadoCorrectamente = false;
          HiNotification.Toast(resultTag.Mensaje);
        }
      });
      this.valorCampoLectura = '';
    },

    ObtenerTodosLosPedidosPlanificadosDeLaLinea() {
      Log(this, this.ObtenerTodosLosPedidosPlanificadosDeLaLinea.name);
      const self = this;
      self.mostrarPrecarga = true;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      callObtenerPedidosPlanificadosPuntoDePaletizado(
        this.puntoDePaletizadoSeleccionado.Id,
      ).then((result) => {
        if (result.Valor) {
          self.listadoPedidosPlanificados = JSON.parse(result.Mensaje);
          self.ProcesarListaPedidosPlanificados();
          if (self.pedidoEnCurso == null) {
            self.ObtenerPosiblePaleEnCursoSinPedidoPlanificado();
          }
          self.mostrarPrecarga = false;

          self.listadoPedidosPlanificados.forEach((element) => {
            element.EnvasesConfeccionados = 0;
          });

          if (self.puntoDePaletizadoSeleccionado.UtilizarUIC && !self.noMostrarEnvasesConfeccionadosUIC) {
            self.ArticulosElaboradosXLineasPedidoVenta();
          }
        } else {
          self.mostrarPrecarga = false;
          if (result.Codigo === '214') {
            // No hay pedidos planificados pero puede existir un pale en curso.
            self.ObtenerPosiblePaleEnCursoSinPedidoPlanificado();
          } else {
            HiNotification.Toast(result.Mensaje);
          }
        }
      })
        .catch((error) => {
          self.mostrarPrecarga = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.ObtenerTodosLosPedidosPlanificadosDeLaLinea.name, error);
        })
        .finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          self.FiltraNotificacionesDePedidosVisualizados();
          this.PermitirFinPaleLecturaUltimaCaja();
        });
    },

    ObtenerPaleActivoSinPedidoPlanificado() {
      Log(this, this.ObtenerPaleActivoSinPedidoPlanificado.name);
      const self = this;
      self.mostrarPrecarga = true;
      self.mostrarPrecargaPaleActivo = true;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      ConexionTA.callObtenerPaleActivoSinPedidoPlanificado(
        this.puntoDePaletizadoSeleccionado.Id,
      ).then((result) => {
        if (result.Valor) {
          self.mostrarPrecarga = false;
          self.mostrarPrecargaPaleActivo = false;
          self.ProcesarRespuestaPaleActivoSinPedidoPlanificado(JSON.parse(result.Mensaje));
        } else {
          self.mostrarPrecarga = false;
          self.mostrarPrecargaPaleActivo = false;
          self.elementoPaleEnProduccion = {};

          const puntoPaletizadoEnArray = self.puntosDePaletizado.find((punto) => punto.Id === self.puntoDePaletizadoSeleccionado.Id);
          if (puntoPaletizadoEnArray && puntoPaletizadoEnArray.PaleActivo) {
            puntoPaletizadoEnArray.PaleActivo = null;
          }
        }
      })
        .catch((error) => {
          self.mostrarPrecarga = false;
          self.mostrarPrecargaPaleActivo = false;
          HiNotification.Toast(self.$t('common.checkYourConnection'));
          LogError(self, self.ObtenerPaleActivoSinPedidoPlanificado.name, error);
        })
        .finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
        });
    },

    async ArticulosVolcadosAsociadosAlpv() {
      Log(this, this.ArticulosVolcadosAsociadosAlpv.name);
      let resultado = [];
      await callExecuteSPERP(
        'APPTrazabilidad_ListaArticulosPrevistosFamiliaGenericaPedido',
        [{ NombreParametro: 'Id_LineaPedidoVenta', Valor: this.pedidoEnCurso.IdLineaPedidoVenta }],
        'Comun.ArticuloJSON',
      ).then((result) => {
        resultado = result.data;
      });
      return resultado;
    },

    async ArticuloTieneFamiliaGenericaYSinFormulacion() {
      Log(this, this.ArticuloTieneFamiliaGenericaYSinFormulacion.name);
      let resultado = [];
      await callExecuteSPERP(
        'APPTrazabilidad_ArticuloTieneFamiliaGenericaSinFormulacion',
        [{ NombreParametro: 'Id_LineaPedidoVenta', Valor: this.pedidoEnCurso.IdLineaPedidoVenta }],
        'Comun.ArticuloJSON',
      ).then((result) => {
        resultado = result.data;
      });
      return resultado;
    },

    async ActualizarTipoEnvasadoXPuntoPaletizado() {
      Log(this, this.ActualizarTipoEnvasadoXPuntoPaletizado.name);
      const tipoEnv = this.tipoEnvasadoElementoProduccionSeleccionado;
      const result = await ConexionTA.callCambiarTipoEnvasadoXPuntoPaletizado(this.puntoDePaletizadoSeleccionado.Id, tipoEnv.Pale.Id, tipoEnv.Envase.Id, tipoEnv.Articulo.Id, tipoEnv.Marca.Id, tipoEnv.EnvasesPorPale);
      return result.Valor;
    },

    GuardarOrdenPedidosActuales() {
      Log(this, this.GuardarOrdenPedidosActuales.name);
      // Obtenemos los identificadores de pedido en el orden actual.
      let tempCadenaIds = '';
      for (let i = 0; i < this.listadoPedidosPlanificados.length; i += 1) {
        tempCadenaIds = `${tempCadenaIds},${this.listadoPedidosPlanificados[i].IdPartesProduccionPrevistoSalidaPuntoPaletizado}`;
      }
      tempCadenaIds = tempCadenaIds.substring(1, tempCadenaIds.length);

      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      callCambiarOrdenPedidosPlanificados(tempCadenaIds).then((result) => {
        if (result.Valor) {
          HiNotification.Toast(this.$t('production.palletizing.info.orderChangedSuccessfully'));
          // TODO ACTUALIZAR EL ORDEN DE LOS ELEMENTOS ACTUALES.
        } else {
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.GuardarOrdenPedidosActuales.name, error);
        })
        .finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
        });
    },

    MoverPalePuntoPaletizadoParaRetrabajarlo(idPale, idPPDestino) {
      Log(this, this.MoverPalePuntoPaletizadoParaRetrabajarlo.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callMoverPalePuntoPaletizadoParaRetrabajarlo(idPale, idPPDestino).then((result) => {
          if (result.Valor) {
            resolve();
            HiNotification.Toast(this.$t('production.palletizing.info.palletReopenedForRework'));
            self.RestablecerUbicacionDefectoPuntoPaletizadoSeleccionado();
          } else {
            reject(result.Mensaje);
            // HiNotification.Alert(result.Mensaje, "No es posible el retrabajo");
          }
        })
          .catch((error) => {
            reject(error);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    EliminarPaleEnCursoEnPuntoPaletizado(idPuntoPaletizado, idLineaPedido, idPartesProduccionPrevistoSalidaPuntoPaletizado, idOrdenProduccion) {
      Log(this, this.EliminarPaleEnCursoEnPuntoPaletizado.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.palletizing.resetPalletizingPoint.preloaderText'));
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callEliminarPaleEnCursoEnPuntoPaletizado(idPuntoPaletizado, idLineaPedido, idPartesProduccionPrevistoSalidaPuntoPaletizado, idOrdenProduccion).then((result) => {
          HiDialog.Preloader(false);
          resolve(result);
        })
          .catch((error) => {
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            reject(error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },
    async ObtenerDatoComplementarioNACxEnvase(idEnvase) {
      Log(this, this.ObtenerDatoComplementarioNACxEnvase.name);
      try {
        let result = null;

        result = await callExecuteSPERP(
          'APPTRAZABILIDAD_ObtenerNumeroEtiquetasTrabajadorXEnvase',
          [{ NombreParametro: 'Id_Envase', Valor: idEnvase }],
          'DatoComplementarioJSON',
        );
        if (result.statusText === 'OK' && result.data.length > 0) {
          this.cantidadLecturaContinuaReg = result.data[0].Valor;
        }
      } catch (error) {
        LogError(this, this.ObtenerDatoComplementarioNACxEnvase.name, error);
        this.showPreload = false;
      }
    },

    Conexion_ActualizarCantidadDePalesPlanificadosDeUnaLineaPedidoVenta(idPuntoPaletizado, idLineaPedidoVenta, idParteProduccionPrevistoSalidaPuntoPaletizado, idOrdenProduccion) {
      Log(this, this.Conexion_ActualizarCantidadDePalesPlanificadosDeUnaLineaPedidoVenta.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido(
          idPuntoPaletizado,
          idLineaPedidoVenta,
          idParteProduccionPrevistoSalidaPuntoPaletizado,
          idOrdenProduccion,
        )
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    Conexion_AsignarTagNFCPale(tag, idNumeroSerie) {
      Log(this, this.Conexion_AsignarTagNFCPale.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callAsignarTagNFCPorPale(tag, idNumeroSerie)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async Conexion_ObtenerPaleEnCursoPuntoPaletizado(puntoPaletizado) {
      Log(this, this.Conexion_ObtenerPaleEnCursoPuntoPaletizado.name);
      if (puntoPaletizado == null) {
        return null;
      }
      PreloaderGH(true, true, this.$t('production.palletizing.info.loadingPalletBoxes'));
      let paleEnCurso = null;
      const result = await ConexionTA.callObtenerUltimosPalesConfeccionadosYEnConfeccion(puntoPaletizado.Id, 0);
      if (result.Valor) {
        const resJSON = JSON.parse(result.Mensaje);
        paleEnCurso = resJSON.PalesEnCurso.length > 0 ? resJSON.PalesEnCurso[0] : null;
      }
      PreloaderGH(false);
      if (paleEnCurso != null) {
        return { Id: paleEnCurso.Id_NumeroSerie };
      }
      return null;
    },
    async ArticulosElaboradosXLineasPedidoVenta() {
      Log(this, this.ArticulosElaboradosXLineasPedidoVenta.name);
      let resultado = [];
      const cadenaIdsLinea = this.listadoPedidosPlanificados.map((ped) => ped.IdLineaPedidoVenta).join(',');
      await callExecuteSPERP(
        'APPERPAGRO_ArticulosElaboradosXLineaPedidoVenta',
        [{ NombreParametro: 'idLPV', Valor: cadenaIdsLinea }],
        'EnvasesConfeccionadosXLineaPedidoJSON',
      ).then((result) => {
        resultado = result.data;
      });
      this.AniadirEnvasesConfeccionadosXLinea(resultado);
    },

    EliminarPedidoPlanificadoEnPuntoPaletizado(idParteProduccionPrevSalidaPPal, idPuntoPaletizado, idLineaPedidoVenta) {
      Log(this, this.EliminarPedidoPlanificadoEnPuntoPaletizado.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarFabricacionLineaPedido(
          idParteProduccionPrevSalidaPPal,
          idPuntoPaletizado,
          idLineaPedidoVenta,
        )
          .then((result) => {
            if (result.Valor) {
              resolve();
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            reject();
            LogError(this, this.EliminarPedidoPlanificadoEnPuntoPaletizado.name, error);
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.div-contenido {
  margin-left: 100px;
  margin-right: 10px;
}

.menu {
  background-color: #ebecf0;
  box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
  width: 80px;
  height: 100vh;
  float: left;
}

.div-pedidosPlanificados {
  padding: 3px;
  margin-top: 3px;
  max-height: 100%;
  overflow-y: auto;
}

.div-pedidosPlanificadosContenedorGrande {
  height: 67vh;
}

.div-pedidosPlanificadosContenedorPequeno {
  height: 54vh;
}

.div-contenedorPartidasLinea {
  background-color: #ebecf0;
  border-radius: 4px 4px 10px 10px;
  border: 2px solid #ebecf0;
  min-height: 33vh;
  margin-right: 10px;
  margin-top: 14px;
}

.div-contenedorPartidasLinea .cabecera {
  height: 26px;
  display: flex;
  align-items: center;
  padding-left: 17px;
}

.div-contenedorUltimosPalesGenerados {
  background-color: #ebecf0;
  border-radius: 4px 4px 10px 10px;
  min-height: 33vh;
  margin-right: 10px;
  margin-top: 14px;
}

.div-contenedorUltimosPalesGenerados .cabecera {
  height: 26px;
  display: flex;
  align-items: center;
  padding-left: 17px;
}

.div-elementoTarjetaLinea {
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
  color: var(--his-steel-blue);
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  margin-top: 15px;
  vertical-align: middle;
  padding-top: 15px;
  padding-left: 16px;
  padding-bottom: 15px;
  padding-right: 15px;
}

.div-elementoTarjetaLineaSeleccionada {
  background-color: var(--his-steel-blue);
  color: #fff;
}

.div-elementoTarjeta {
  background-color: #fff;
  color: var(--his-steel-blue);
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  margin-top: 15px;
  vertical-align: middle;
  border: 2px solid #fafbfc;
  border-radius: 4px;
  box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
}

.div-elementoTarjeta .row-cabeceraTarjeta {
  min-height: 34px;
  background-color: #fafbfc;
  border-radius: 4px 4px 0 0;
  align-items: center;
}

.div-elementoTarjeta .row-cabeceraTarjetaSeleccionada {
  padding-bottom: 0;
  min-height: 50px;
  background-color: var(--his-kiwi-pulp);
  border-radius: 4px 4px 0 0;
  align-items: center;
}

.div-elementoTarjetaSeleccionado {
  border: 2px solid var(--his-kiwi-pulp);
  border-radius: 4px;
}

.div-tarjetaPaleSinPedido {
  padding-bottom: 10px;
}

.span-tituloColumnas {
  color: var(--his-plum-shadow);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
  text-transform: uppercase;
}

.div-puntosPaletizadoDisponibles {
  max-height: 100%;
  height: 78vh;
  overflow-y: auto;

  &__orange-icon {
    border-radius: 50%;
    height: 12px;
    width: 12px;
    margin-right: 5px;
    background-color: var(--his-orange);
    display: inline-block;
  }

  &__pale-activo-info {
    display: flex;
    flex-direction: column;
    margin-top: 4px;
    gap: 6px;
    font-size: small;
    text-wrap: pretty;
    color: var(--his-steel-blue);

    > div {
      background-color: var(--his-silver);
      padding: 2px 7px;
      border-radius: 3px;
    }
  }
}

.div-contenedorCentralPedidos {
  padding-top: 5px;
}

.div-cabeceraTarjetaDerecha {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.div-rectanguloEnCurso,
.div-rectanguloReabierto {
  border-radius: 3px;
  width: 78px;
  height: 19px;
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.div-rectanguloEnCurso {
  background-color: var(--his-mandarina);
}

.div-rectanguloReabierto {
  background-color: #ff3b30;
}

.div-rectanguloModificado {
  background-color: #ff3b30;
  border-radius: 3px;
  width: 30px;
  height: 19px;
  text-align: center;
}

.div-rectanguloModificado span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

.div-rectanguloEnCurso,
.div-rectanguloReabierto span {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

.div-barraDeOpcionesPlanificacion {
  height: 48px;
  background-color: var(--his-metal);
  margin-top: 10px;
  text-align: center;
}

.div-barraDeOpcionesPlanificacion .div-btnIzquierda {
  float: left;
  display: flex;
  margin-left: 5px;
}

.div-barraDeOpcionesPlanificacion .div-btnDerecha {
  float: right;
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.div-frmPaletizadoInicio {
  //TODO: Remove when migrated to new styles
  --f7-grid-row-gap: 0;

  .page {
    background-color: var(--f7-page-bg-color);
  }
  //

  --information-bar-padding-bottom: 0;
  height: 100%;
}

.col-rectanguloIndicadorDePedido {
  background-color: rgb(247 248 250);
  width: 55px;
  height: 60px;
  display: grid;
  padding-top: 12px;
  padding-left: 2px;
  padding-right: 2px;
  padding-bottom: 1px;
  text-align: center;
  border-radius: 10px;
}

.span-valorInidicadorDePedido {
  color: var(--his-darkgray);
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
}

.span-textoCabeceraTarjetaPedido {
  margin-left: 10px;
  margin-right: 10px;
}

.row-pedido {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;

  .footer {
    display: flex;
    justify-content: space-between;
    width: 95%;

    .footer-quantity {
      background-color: var(--his-mandarina-tint);
      padding: 4px 8px;
      border-radius: 3px;
      line-height: 1;
    }
  }

  .footer-planificado {
    display: flex;
    justify-content: flex-end;
    width: 100%;

    .footer-quantity {
      background-color: var(--his-mandarina-tint);
      padding: 4px 8px;
      border-radius: 3px;
      line-height: 1;
    }
  }

  .img-details {
    display: flex;
    width: 85%;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
}

.row-envase {
  margin-top: 3px;
}

.row-paleYCamara {
  margin-top: 3px;
}

.row-indicadoresPedido {
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.row-producto {
  margin-top: 3px;
}

.selector-lineaproduccion {
  background-color: rgb(9 30 66 / 4%);
  border: 1px solid rgb(9 30 66 / 25%);
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgb(9 30 66 / 4%);
  height: 58px;
}

.selector-lineaproduccion-textolinea {
  color: var(--his-steel-blue);
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  vertical-align: middle;
  padding-top: 15px;
  padding-left: 16px;
}

.lineas-disponibles {
  color: var(--his-plum-shadow);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.div-contenidoComponentePCPartidasActivasYRecintesLinea {
  height: 30vh;
  overflow-y: auto;
}

.div-contenidoComponentePCUltimosPalesGenerados {
  height: 30vh;
  overflow-y: auto;
}

.col-componenteUCLineasDeProduccion {
  margin-top: 0;
  margin-left: 25px;
  margin-right: 25px;
}

.span-verMas {
  color: var(--his-kiwi-pulp);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;
  line-height: 14px;
  text-align: left;
}

.div-verMas {
  padding-bottom: 6px;
  padding-top: 6px;
}

/*  Estilos de las listas Dragg */
.sortable-ghost {
  max-height: 34px;
  background: red;
  overflow: hidden;
  display: block;
}

.sortable-fallback {
  background: #fff;
  border: 2px solid yellow;
  opacity: 1 !important;
  overflow: hidden;
  max-height: 50px;
}

.btn-actualizarPartidasYPalesGenerados {
  float: right;
  margin-right: 16px;
}

.btn-resetearVolcadosActivos {
  float: right;
  margin-right: 16px;
}

.div-elementoTarjetaLineaDeshabilitada {
  opacity: 0.3;
  pointer-events: none;

  /* Deshabilita el pulsado */
}

.div-logoHispatecDerecha {
  max-width: 250px;
  margin-top: 18px;
  border-left: 1px solid rgb(151 151 151 / 30%);
  text-align: end;
  padding-right: 15px;

  /* height: 79px; */
}

/*****  Popup Configuracion Formulario *****/

.div-btnResetearPP {
  background-color: rgb(172 160 149 / 20%);
  border: 1px solid var(--his-kiwi-pulp);
  border-radius: 8px;
  width: 184px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-btnResetearPP span {
  color: var(--his-kiwi-pulp);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.26px;
  line-height: 22px;
  text-align: center;
}

.img-logoHispatec {
  padding-left: 45px;
}

.div-popupDetallePedidoSeleccionado {
  --f7-popup-tablet-height: 90vh;

  .order-details-card-header {
    padding: calc(var(--f7-typography-padding) / 2) var(--f7-typography-padding);
    background-color: var(--his-silver);
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--his-oliva);
    font-size: 14px;
    font-weight: 400;
    display: -webkit-flex;
    white-space: normal;
    -webkit-line-clamp: 1;
    -webkit-align-items: center;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }

  .order-details-card-info {
    padding: var(--f7-typography-padding);
    background-color: #fff;
    border-radius: 0 0 6px 6px;

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &__title {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        color: var(--his-navy-night);
        font-weight: 600;
        font-size: 14px;
      }
    }

    &__subtitle {
      display: -webkit-box;
      white-space: normal;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-top: 10px;
      color: var(--his-ash-gray);
      font-size: 500;
      font-size: 14px;
    }

    &__text {
      color: var(--his-plum-shadow);
      font-size: 13px;
      font-weight: 400;
    }

    &__footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;

      &--items {
        display: flex;
        align-items: center;

        div {
          display: flex;
          align-items: center;
          gap: 10px;

          span {
            color: var(--his-steel-blue);
            font-size: 16px;
            font-weight: 600;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .order-details-accordion {
    --f7-block-title-font-size: 18px;
    --f7-block-title-font-weight: bold;
    --f7-block-title-line-height: initial;
    --f7-block-title-text-color: var(--his-dark-blue);
    --f7-list-item-title-text-color: var(--his-steel-blue);
    --f7-list-chevron-icon-color: var(--his-steel-blue);

    :deep(.accordion-item > a .item-content) {
      background-color: #FAFBFC;
      border-bottom: 1px solid #EBECF0;
    }
  }
}

.div-cabecera-puntos {
  display: flex;
}

.btn-opciones-puntos {
  margin-left: auto;
}

.span-ubic-salida-mod {
  display: block;
  margin-block-start: 0.2em;
  margin-block-end: 0.2em;
  font-size: smaller;
  color: var(--his-orange);
}

.temp-padding-top {
  padding-top: 20px;
}

.edicionPedidoPlanificado-popup {
  background-color: #fff;
  overflow-y: hidden;
}

.content-action-sheet-incidencias {
  background-color: #fff;

  &__search {
    padding-bottom: 2vh;
  }

  &__buttons {
    display: flex;
    align-items: center;
    margin-top: 15px;
    padding-top: 2vh;
    justify-content: space-between;

    a {
      font-size: 14px;
      font-weight: 500;
    }
  }

  .actions-label::after {
    height: 0 !important;
  }
}

.nfcScann-popup {
  --f7-popup-tablet-width: 500px;
  --f7-popup-tablet-height: 600px;

  .img-nfc {
    display: flex;
    height: 90%;
    align-content: center;
    justify-content: center;
    flex-direction: column;

    img {
      height: 365px;
    }
  }
}

.div-input {
  background: #fff;
  margin-right: 18px;
  margin-left: 18px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  min-height: 60px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.input-searchCodeBars {
  width: 100%;
  height: 100%;
  padding-left: 19px;
  padding-right: 19px;
  color: #24253da8;
  font-size: 17px;
  margin-top: 22px;
  margin-bottom: 16px;
}

.content-origin-data-asignation-popup {
  &__buttons {
    background: #fff;

    .content-buttons-origin-data-asignation {
      display: flex;
      justify-content: space-between;
      flex-direction: row;

      .button-reject {
        color: var(--his-darkgray);
      }

      .button-confirm {
        color: var(--his-orange);
        font-size: 16px;
      }
    }
  }
}

.content-action {
  .actions-group {
    height: 200px;

    .actions-label {
      color: var(--his-slate-blue);
      font-size: 16px;
    }

    .content-action__input {
      display: flex;
      justify-content: center;
      width: 100%;

      .input {
        color: var(--his-slate-blue);
        padding: 10px 0;
        height: 30%;
        width: 40%;
      }
    }

    .content-action__buttons {
      display: flex;
      justify-content: space-between;

      .actions-button--cancelar {
        background: #fff;
        color: gray;

        .actions-button-text {
          font-size: 14px;
        }
      }

      .actions-button--guardar {
        background: #fff;
        color: green;

        .actions-button-text {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
